function PlanC({ ...props }) {
	return (
		<g {...props} id="unit-c">
			<g id="furniture">
				<polyline
					points="369.43 677.84 366.72 677.84 366.72 672.47 369.43 672.47 369.43 677.84"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="837.74"
					y1="929.66"
					x2="840.58"
					y2="929.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth="0"
				/>
				<line
					x1="782.29"
					y1="928.75"
					x2="818.45"
					y2="928.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="782.29"
					y1="826.36"
					x2="782.29"
					y2="928.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="818.45"
					y1="928.75"
					x2="818.45"
					y2="925.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="818.45"
					y1="922.11"
					x2="818.45"
					y2="916.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="818.45"
					y1="912.85"
					x2="818.45"
					y2="907.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="818.45"
					y1="903.59"
					x2="818.45"
					y2="897.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="818.45"
					y1="894.34"
					x2="818.45"
					y2="888.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="818.45"
					y1="885.08"
					x2="818.45"
					y2="879.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="818.45"
					y1="875.82"
					x2="818.45"
					y2="870.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="809.1"
					y1="826.36"
					x2="803.31"
					y2="826.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="799.84"
					y1="826.36"
					x2="794.06"
					y2="826.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="790.59"
					y1="826.36"
					x2="784.7"
					y2="826.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="784.7"
					y1="826.36"
					x2="784.7"
					y2="829.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="784.7"
					y1="833.01"
					x2="784.7"
					y2="838.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="784.7"
					y1="842.27"
					x2="784.7"
					y2="848.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="784.7"
					y1="851.53"
					x2="784.7"
					y2="857.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="784.7"
					y1="860.78"
					x2="784.7"
					y2="866.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="784.7"
					y1="870.04"
					x2="784.7"
					y2="875.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="784.7"
					y1="879.29"
					x2="784.7"
					y2="885.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="784.7"
					y1="888.55"
					x2="784.7"
					y2="894.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="784.7"
					y1="897.81"
					x2="784.7"
					y2="903.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="784.7"
					y1="907.06"
					x2="784.7"
					y2="912.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="784.7"
					y1="916.32"
					x2="784.7"
					y2="922.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="784.7"
					y1="925.58"
					x2="784.7"
					y2="928.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="784.7"
					y1="928.75"
					x2="790.59"
					y2="928.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="794.06"
					y1="928.75"
					x2="799.84"
					y2="928.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="803.31"
					y1="928.75"
					x2="809.1"
					y2="928.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="812.57"
					y1="928.75"
					x2="818.45"
					y2="928.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="744.12"
					y1="466.74"
					x2="576.49"
					y2="466.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="744.12"
					y1="493.55"
					x2="744.12"
					y2="487.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="744.12"
					y1="484.29"
					x2="744.12"
					y2="478.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="744.12"
					y1="475.03"
					x2="744.12"
					y2="469.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="744.12"
					y1="469.15"
					x2="740.72"
					y2="469.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="737.25"
					y1="469.15"
					x2="731.47"
					y2="469.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="727.99"
					y1="469.15"
					x2="722.21"
					y2="469.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="718.74"
					y1="469.15"
					x2="712.95"
					y2="469.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="709.48"
					y1="469.15"
					x2="703.69"
					y2="469.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="700.22"
					y1="469.15"
					x2="694.44"
					y2="469.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="690.97"
					y1="469.15"
					x2="685.18"
					y2="469.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="681.71"
					y1="469.15"
					x2="675.92"
					y2="469.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="672.45"
					y1="469.15"
					x2="666.67"
					y2="469.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="663.2"
					y1="469.15"
					x2="657.41"
					y2="469.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="653.94"
					y1="469.15"
					x2="648.15"
					y2="469.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="644.68"
					y1="469.15"
					x2="638.9"
					y2="469.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="635.43"
					y1="469.15"
					x2="629.64"
					y2="469.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="626.17"
					y1="469.15"
					x2="620.38"
					y2="469.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="616.91"
					y1="469.15"
					x2="611.13"
					y2="469.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="607.65"
					y1="469.15"
					x2="601.87"
					y2="469.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="598.4"
					y1="469.15"
					x2="592.61"
					y2="469.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="589.14"
					y1="469.15"
					x2="583.35"
					y2="469.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="579.88"
					y1="469.15"
					x2="576.49"
					y2="469.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="576.49"
					y1="469.15"
					x2="576.49"
					y2="475.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="576.49"
					y1="478.5"
					x2="576.49"
					y2="484.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="576.49"
					y1="487.76"
					x2="576.49"
					y2="493.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="364"
					y1="686.82"
					x2="237.28"
					y2="686.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="237.28"
					y1="686.82"
					x2="237.28"
					y2="447.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="349.88 65.19 349.77 67.6 225.06 61.44 225.18 59.03 349.88 65.19"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="349.88"
					y1="65.19"
					x2="349.77"
					y2="67.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="349.77"
					y1="67.6"
					x2="225.06"
					y2="61.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="225.06"
					y1="61.44"
					x2="225.18"
					y2="59.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="225.18"
					y1="59.03"
					x2="349.88"
					y2="65.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="400.77 66.76 358.5 64.67 358.24 69.88 400.52 71.97 400.77 66.76"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="356.63 64.1 402.69 66.38 402.67 66.85 356.6 64.57 356.63 64.1"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="356.63"
					y1="64.1"
					x2="402.69"
					y2="66.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="402.69"
					y1="66.38"
					x2="402.67"
					y2="66.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="402.67"
					y1="66.85"
					x2="356.6"
					y2="64.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="356.6"
					y1="64.57"
					x2="356.63"
					y2="64.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="400.52"
					y1="71.97"
					x2="358.24"
					y2="69.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="358.5"
					y1="64.67"
					x2="400.77"
					y2="66.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="404.78 72.18 400.52 71.97 400.77 66.76 405.04 66.97 404.78 72.18"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="404.78"
					y1="72.18"
					x2="400.52"
					y2="71.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="400.52"
					y1="71.97"
					x2="400.77"
					y2="66.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="400.77"
					y1="66.76"
					x2="405.04"
					y2="66.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="405.04"
					y1="66.97"
					x2="404.78"
					y2="72.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="354.23 64.46 358.5 64.67 358.24 69.88 353.98 69.67 354.23 64.46"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="354.23"
					y1="64.46"
					x2="358.5"
					y2="64.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="358.5"
					y1="64.67"
					x2="358.24"
					y2="69.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="358.24"
					y1="69.88"
					x2="353.98"
					y2="69.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="353.98"
					y1="69.67"
					x2="354.23"
					y2="64.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="400.72"
					y1="67.7"
					x2="358.45"
					y2="65.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="406.7 71.8 404.81 71.71 405.04 66.97 402.67 66.85 402.69 66.38 406.96 66.59 406.7 71.8"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="406.7"
					y1="71.8"
					x2="404.81"
					y2="71.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="404.81"
					y1="71.71"
					x2="405.04"
					y2="66.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="405.04"
					y1="66.97"
					x2="402.67"
					y2="66.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="402.67"
					y1="66.85"
					x2="402.69"
					y2="66.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="402.69"
					y1="66.38"
					x2="406.96"
					y2="66.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="406.96"
					y1="66.59"
					x2="406.7"
					y2="71.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="352.36 63.89 356.63 64.1 356.6 64.57 354.23 64.46 354 69.2 352.11 69.1 352.36 63.89"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="352.36"
					y1="63.89"
					x2="356.63"
					y2="64.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="356.63"
					y1="64.1"
					x2="356.6"
					y2="64.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="356.6"
					y1="64.57"
					x2="354.23"
					y2="64.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="354.23"
					y1="64.46"
					x2="354"
					y2="69.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="354"
					y1="69.2"
					x2="352.11"
					y2="69.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="352.11"
					y1="69.1"
					x2="352.36"
					y2="63.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="347.48 65.07 352.29 65.31 351.58 79.76 346.76 79.52 347.48 65.07"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="352.29"
					y1="65.31"
					x2="347.48"
					y2="65.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="351.58"
					y1="79.76"
					x2="352.29"
					y2="65.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="346.76"
					y1="79.52"
					x2="351.58"
					y2="79.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="347.48"
					y1="65.07"
					x2="346.76"
					y2="79.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="411.7 68.25 410.99 82.69 406.17 82.46 406.89 68.01 411.7 68.25"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="410.99"
					y1="82.69"
					x2="411.7"
					y2="68.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="406.17"
					y1="82.46"
					x2="410.99"
					y2="82.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="406.89"
					y1="68.01"
					x2="406.17"
					y2="82.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="411.7"
					y1="68.25"
					x2="406.89"
					y2="68.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="222.77 58.91 227.58 59.15 226.87 73.59 222.06 73.36 222.77 58.91"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="227.58"
					y1="59.15"
					x2="222.77"
					y2="58.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="226.87"
					y1="73.59"
					x2="227.58"
					y2="59.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="222.06"
					y1="73.36"
					x2="226.87"
					y2="73.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="222.77"
					y1="58.91"
					x2="222.06"
					y2="73.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="642.97 79.68 642.85 82.08 545.82 77.29 545.94 74.88 642.97 79.68"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="642.97"
					y1="79.68"
					x2="642.85"
					y2="82.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="642.85"
					y1="82.08"
					x2="545.82"
					y2="77.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="545.82"
					y1="77.29"
					x2="545.94"
					y2="74.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="545.94"
					y1="74.88"
					x2="642.97"
					y2="79.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="690.87 81.09 651.58 79.15 651.32 84.36 690.61 86.31 690.87 81.09"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="649.71 78.58 692.79 80.71 692.76 81.19 649.69 79.06 649.71 78.58"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="649.71"
					y1="78.58"
					x2="692.79"
					y2="80.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="692.79"
					y1="80.71"
					x2="692.76"
					y2="81.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="692.76"
					y1="81.19"
					x2="649.69"
					y2="79.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="649.69"
					y1="79.06"
					x2="649.71"
					y2="78.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="690.61"
					y1="86.31"
					x2="651.32"
					y2="84.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="651.58"
					y1="79.15"
					x2="690.87"
					y2="81.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="694.87 86.52 690.61 86.31 690.87 81.09 695.13 81.3 694.87 86.52"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="694.87"
					y1="86.52"
					x2="690.61"
					y2="86.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="690.61"
					y1="86.31"
					x2="690.87"
					y2="81.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="690.87"
					y1="81.09"
					x2="695.13"
					y2="81.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="695.13"
					y1="81.3"
					x2="694.87"
					y2="86.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="647.32 78.94 651.58 79.15 651.32 84.36 647.06 84.15 647.32 78.94"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="647.32"
					y1="78.94"
					x2="651.58"
					y2="79.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="651.58"
					y1="79.15"
					x2="651.32"
					y2="84.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="651.32"
					y1="84.36"
					x2="647.06"
					y2="84.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="647.06"
					y1="84.15"
					x2="647.32"
					y2="78.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="690.82"
					y1="82.04"
					x2="651.54"
					y2="80.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="696.79 86.14 694.9 86.04 695.13 81.3 692.76 81.19 692.79 80.71 697.05 80.92 696.79 86.14"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="696.79"
					y1="86.14"
					x2="694.9"
					y2="86.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="694.9"
					y1="86.04"
					x2="695.13"
					y2="81.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="695.13"
					y1="81.3"
					x2="692.76"
					y2="81.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="692.76"
					y1="81.19"
					x2="692.79"
					y2="80.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="692.79"
					y1="80.71"
					x2="697.05"
					y2="80.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="697.05"
					y1="80.92"
					x2="696.79"
					y2="86.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="645.45 78.37 649.71 78.58 649.69 79.06 647.32 78.94 647.08 83.68 645.19 83.59 645.45 78.37"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="645.45"
					y1="78.37"
					x2="649.71"
					y2="78.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="649.71"
					y1="78.58"
					x2="649.69"
					y2="79.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="649.69"
					y1="79.06"
					x2="647.32"
					y2="78.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="647.32"
					y1="78.94"
					x2="647.08"
					y2="83.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="647.08"
					y1="83.68"
					x2="645.19"
					y2="83.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="645.19"
					y1="83.59"
					x2="645.45"
					y2="78.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="543.53 74.76 548.34 75 547.63 89.45 542.82 89.21 543.53 74.76"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="548.34"
					y1="75"
					x2="543.53"
					y2="74.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="547.63"
					y1="89.45"
					x2="548.34"
					y2="75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="542.82"
					y1="89.21"
					x2="547.63"
					y2="89.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="543.53"
					y1="74.76"
					x2="542.82"
					y2="89.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="640.56 79.56 645.37 79.79 644.66 94.24 639.85 94 640.56 79.56"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="645.37"
					y1="79.79"
					x2="640.56"
					y2="79.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="644.66"
					y1="94.24"
					x2="645.37"
					y2="79.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="639.85"
					y1="94"
					x2="644.66"
					y2="94.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="640.56"
					y1="79.56"
					x2="639.85"
					y2="94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="701.8 82.58 701.08 97.03 696.27 96.79 696.98 82.35 701.8 82.58"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="701.08"
					y1="97.03"
					x2="701.8"
					y2="82.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="696.27"
					y1="96.79"
					x2="701.08"
					y2="97.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="696.98"
					y1="82.35"
					x2="696.27"
					y2="96.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="701.8"
					y1="82.58"
					x2="696.98"
					y2="82.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="702.03"
					y1="77.77"
					x2="701.08"
					y2="97.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="364"
					y1="744.68"
					x2="344.71"
					y2="744.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="364"
					y1="766.39"
					x2="364"
					y2="744.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="445.51"
					y1="766.39"
					x2="364"
					y2="766.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="708.18"
					y1="942.9"
					x2="711.79"
					y2="943.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="709.08"
					y1="923.63"
					x2="712.69"
					y2="923.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="709.08"
					y1="923.63"
					x2="708.18"
					y2="942.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="840.58"
					y1="929.79"
					x2="837.74"
					y2="929.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<polyline
					points="706.92 944.05 711.73 944.27 711.79 943.07 706.97 942.84 706.92 944.05"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="707.88 923.58 712.69 923.8 712.75 922.6 707.93 922.37 707.88 923.58"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="706.92"
					y1="944.05"
					x2="711.73"
					y2="944.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="711.73"
					y1="944.27"
					x2="711.79"
					y2="943.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="711.79"
					y1="943.07"
					x2="706.97"
					y2="942.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="706.97"
					y1="942.84"
					x2="706.92"
					y2="944.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="617.82"
					y1="939.88"
					x2="617.88"
					y2="938.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="707.88"
					y1="923.58"
					x2="712.69"
					y2="923.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="712.69"
					y1="923.8"
					x2="712.75"
					y2="922.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="712.75"
					y1="922.6"
					x2="707.93"
					y2="922.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="707.93"
					y1="922.37"
					x2="707.88"
					y2="923.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="618.78"
					y1="919.41"
					x2="618.84"
					y2="918.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="705.77 942.78 707.58 942.87 708.48 923.61 706.67 923.52 705.77 942.78"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="617.27 938.64 619.08 938.73 619.98 919.46 618.18 919.38 617.27 938.64"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="684.15 861.03 619.98 919.46 622.82 922.58 686.99 864.15 684.15 861.03"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="708.48"
					y1="923.61"
					x2="709.08"
					y2="923.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="707.58"
					y1="942.87"
					x2="708.18"
					y2="942.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="709.08"
					y1="923.63"
					x2="708.18"
					y2="942.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="618.18"
					y1="919.38"
					x2="617.57"
					y2="919.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="705.77"
					y1="942.78"
					x2="706.67"
					y2="923.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="706.67"
					y1="923.52"
					x2="708.48"
					y2="923.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="708.48"
					y1="923.61"
					x2="707.58"
					y2="942.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="707.58"
					y1="942.87"
					x2="705.77"
					y2="942.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="617.27"
					y1="938.64"
					x2="618.18"
					y2="919.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="618.18"
					y1="919.38"
					x2="619.98"
					y2="919.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="619.98"
					y1="919.46"
					x2="619.08"
					y2="938.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="619.08"
					y1="938.73"
					x2="617.27"
					y2="938.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="684.15"
					y1="861.03"
					x2="686.99"
					y2="864.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="686.99"
					y1="864.15"
					x2="622.82"
					y2="922.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="622.82"
					y1="922.58"
					x2="619.98"
					y2="919.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="619.98"
					y1="919.46"
					x2="684.15"
					y2="861.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="709.08"
					y1="923.63"
					x2="708.18"
					y2="942.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="709.08"
					y1="923.63"
					x2="708.18"
					y2="942.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="709.08"
					y1="923.63"
					x2="712.69"
					y2="923.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="709.08"
					y1="923.63"
					x2="712.69"
					y2="923.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="708.18"
					y1="942.9"
					x2="711.79"
					y2="943.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="708.18"
					y1="942.9"
					x2="711.79"
					y2="943.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="458.36"
					y1="542.16"
					x2="458.36"
					y2="554.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="549.96"
					y1="554.21"
					x2="553.58"
					y2="554.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="549.96"
					y1="542.16"
					x2="553.58"
					y2="542.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="549.96"
					y1="542.16"
					x2="549.96"
					y2="554.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<polyline
					points="548.76 555.41 553.58 555.41 553.58 554.21 548.76 554.21 548.76 555.41"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="548.76 542.16 553.58 542.16 553.58 540.95 548.76 540.95 548.76 542.16"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="548.76"
					y1="555.41"
					x2="553.58"
					y2="555.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="553.58"
					y1="555.41"
					x2="553.58"
					y2="554.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="553.58"
					y1="554.21"
					x2="548.76"
					y2="554.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="548.76"
					y1="554.21"
					x2="548.76"
					y2="555.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="459.56"
					y1="555.41"
					x2="459.56"
					y2="554.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="548.76"
					y1="542.16"
					x2="553.58"
					y2="542.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="553.58"
					y1="542.16"
					x2="553.58"
					y2="540.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="553.58"
					y1="540.95"
					x2="548.76"
					y2="540.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="548.76"
					y1="540.95"
					x2="548.76"
					y2="542.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="459.56"
					y1="542.16"
					x2="459.56"
					y2="540.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="547.55 554.21 549.36 554.21 549.36 542.16 547.55 542.16 547.55 554.21"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="458.96 554.21 460.77 554.21 460.77 542.16 458.96 542.16 458.96 554.21"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="522.13 480.79 460.77 542.16 463.75 545.14 525.12 483.77 522.13 480.79"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="549.36"
					y1="542.16"
					x2="549.96"
					y2="542.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="549.36"
					y1="554.21"
					x2="549.96"
					y2="554.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="549.96"
					y1="542.16"
					x2="549.96"
					y2="554.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="458.96"
					y1="542.16"
					x2="458.36"
					y2="542.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="458.96"
					y1="554.21"
					x2="458.36"
					y2="554.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="458.36"
					y1="542.16"
					x2="458.36"
					y2="554.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="547.55"
					y1="554.21"
					x2="547.55"
					y2="542.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="547.55"
					y1="542.16"
					x2="549.36"
					y2="542.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="549.36"
					y1="542.16"
					x2="549.36"
					y2="554.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="549.36"
					y1="554.21"
					x2="547.55"
					y2="554.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="458.96"
					y1="554.21"
					x2="458.96"
					y2="542.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="458.96"
					y1="542.16"
					x2="460.77"
					y2="542.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="460.77"
					y1="542.16"
					x2="460.77"
					y2="554.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="460.77"
					y1="554.21"
					x2="458.96"
					y2="554.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="522.13"
					y1="480.79"
					x2="525.12"
					y2="483.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="525.12"
					y1="483.77"
					x2="463.75"
					y2="545.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="463.75"
					y1="545.14"
					x2="460.77"
					y2="542.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="460.77"
					y1="542.16"
					x2="522.13"
					y2="480.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="549.96"
					y1="542.16"
					x2="549.96"
					y2="554.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="549.96"
					y1="542.16"
					x2="549.96"
					y2="554.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="549.96"
					y1="542.16"
					x2="553.58"
					y2="542.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="549.96"
					y1="542.16"
					x2="553.58"
					y2="542.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="549.96"
					y1="554.21"
					x2="553.58"
					y2="554.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="549.96"
					y1="554.21"
					x2="553.58"
					y2="554.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="458.36"
					y1="542.16"
					x2="458.36"
					y2="554.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="458.36"
					y1="542.16"
					x2="458.36"
					y2="554.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="576.49"
					y1="554.21"
					x2="576.49"
					y2="542.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="576.49"
					y1="542.16"
					x2="576.49"
					y2="535.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="728.43"
					y1="447.32"
					x2="731.45"
					y2="447.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="728.43"
					y1="444.91"
					x2="728.43"
					y2="447.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="728.43"
					y1="435.27"
					x2="731.45"
					y2="435.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="728.43"
					y1="435.27"
					x2="728.43"
					y2="444.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="587.41"
					y1="447.32"
					x2="584.39"
					y2="447.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="587.41"
					y1="444.91"
					x2="587.41"
					y2="447.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="587.41"
					y1="435.27"
					x2="584.39"
					y2="435.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="587.41"
					y1="435.27"
					x2="587.41"
					y2="444.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="576.49"
					y1="447.32"
					x2="587.41"
					y2="447.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="728.43"
					y1="447.32"
					x2="744.12"
					y2="447.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="744.12"
					y1="435.27"
					x2="728.43"
					y2="435.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="587.41"
					y1="435.27"
					x2="576.49"
					y2="435.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<polyline
					points="589.22 444.91 588.01 444.91 588.01 447.32 589.22 447.32 589.22 444.91"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="589.22 448.53 589.22 447.32 584.39 447.32 584.39 448.53 589.22 448.53"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="727.83 444.91 726.62 444.91 726.62 447.32 727.83 447.32 727.83 444.91"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="726.62 447.32 726.62 448.53 731.45 448.53 731.45 447.32 726.62 447.32"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="589.22 435.27 589.22 432.26 584.39 432.26 584.39 435.27 589.22 435.27"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="726.62 432.26 726.62 435.27 731.45 435.27 731.45 432.26 726.62 432.26"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="589.22"
					y1="444.91"
					x2="589.22"
					y2="447.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="589.22"
					y1="447.32"
					x2="588.01"
					y2="447.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="588.01"
					y1="447.32"
					x2="588.01"
					y2="444.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="588.01"
					y1="444.91"
					x2="589.22"
					y2="444.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="589.22"
					y1="448.53"
					x2="584.39"
					y2="448.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="584.39"
					y1="448.53"
					x2="584.39"
					y2="447.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="584.39"
					y1="447.32"
					x2="589.22"
					y2="447.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="589.22"
					y1="447.32"
					x2="589.22"
					y2="448.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="727.83"
					y1="444.91"
					x2="727.83"
					y2="447.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="727.83"
					y1="447.32"
					x2="726.62"
					y2="447.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="726.62"
					y1="447.32"
					x2="726.62"
					y2="444.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="726.62"
					y1="444.91"
					x2="727.83"
					y2="444.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="726.62"
					y1="447.32"
					x2="731.45"
					y2="447.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="731.45"
					y1="447.32"
					x2="731.45"
					y2="448.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="731.45"
					y1="448.53"
					x2="726.62"
					y2="448.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="726.62"
					y1="448.53"
					x2="726.62"
					y2="447.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="589.22"
					y1="435.27"
					x2="584.39"
					y2="435.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="584.39"
					y1="435.27"
					x2="584.39"
					y2="432.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="584.39"
					y1="432.26"
					x2="589.22"
					y2="432.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="589.22"
					y1="432.26"
					x2="589.22"
					y2="435.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="726.62"
					y1="432.26"
					x2="731.45"
					y2="432.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="731.45"
					y1="432.26"
					x2="731.45"
					y2="435.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="731.45"
					y1="435.27"
					x2="726.62"
					y2="435.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="726.62"
					y1="435.27"
					x2="726.62"
					y2="432.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="592.83 444.91 592.83 435.27 588.01 435.27 588.01 444.91 592.83 444.91"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="727.83 444.91 727.83 435.27 723.01 435.27 723.01 444.91 727.83 444.91"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="655.51 435.27 655.51 439.49 723.01 439.49 723.01 435.27 655.51 435.27"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="621.76 439.49 621.76 443.71 689.26 443.71 689.26 439.49 621.76 439.49"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="588.01"
					y1="435.27"
					x2="587.41"
					y2="435.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="588.01"
					y1="444.91"
					x2="587.41"
					y2="444.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="587.41"
					y1="435.27"
					x2="587.41"
					y2="444.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="727.83"
					y1="435.27"
					x2="728.43"
					y2="435.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="727.83"
					y1="444.91"
					x2="728.43"
					y2="444.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="728.43"
					y1="435.27"
					x2="728.43"
					y2="444.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="592.83"
					y1="444.91"
					x2="592.83"
					y2="435.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="592.83"
					y1="435.27"
					x2="588.01"
					y2="435.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="588.01"
					y1="435.27"
					x2="588.01"
					y2="444.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="588.01"
					y1="444.91"
					x2="592.83"
					y2="444.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="727.83"
					y1="444.91"
					x2="727.83"
					y2="435.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="727.83"
					y1="435.27"
					x2="723.01"
					y2="435.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="723.01"
					y1="435.27"
					x2="723.01"
					y2="444.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="723.01"
					y1="444.91"
					x2="727.83"
					y2="444.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="655.51"
					y1="435.27"
					x2="655.51"
					y2="439.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="655.51"
					y1="439.49"
					x2="723.01"
					y2="439.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="723.01"
					y1="439.49"
					x2="723.01"
					y2="435.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="723.01"
					y1="435.27"
					x2="655.51"
					y2="435.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="621.76"
					y1="439.49"
					x2="621.76"
					y2="443.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="621.76"
					y1="443.71"
					x2="689.26"
					y2="443.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="689.26"
					y1="443.71"
					x2="689.26"
					y2="439.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="689.26"
					y1="439.49"
					x2="621.76"
					y2="439.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="587.41"
					y1="435.27"
					x2="587.41"
					y2="444.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="587.41"
					y1="435.27"
					x2="587.41"
					y2="444.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="587.41"
					y1="444.91"
					x2="587.41"
					y2="447.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="587.41"
					y1="435.27"
					x2="584.39"
					y2="435.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="587.41"
					y1="444.91"
					x2="587.41"
					y2="447.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="587.41"
					y1="447.32"
					x2="584.39"
					y2="447.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="587.41"
					y1="447.32"
					x2="584.39"
					y2="447.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="728.43"
					y1="435.27"
					x2="728.43"
					y2="444.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="728.43"
					y1="435.27"
					x2="728.43"
					y2="444.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="728.43"
					y1="444.91"
					x2="728.43"
					y2="447.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="728.43"
					y1="435.27"
					x2="731.45"
					y2="435.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="728.43"
					y1="444.91"
					x2="728.43"
					y2="447.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="728.43"
					y1="447.32"
					x2="731.45"
					y2="447.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="728.43"
					y1="447.32"
					x2="731.45"
					y2="447.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="576.49"
					y1="700.82"
					x2="576.49"
					y2="554.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="582.28"
					y1="712.88"
					x2="578.67"
					y2="712.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="582.28"
					y1="700.82"
					x2="578.67"
					y2="700.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="582.28"
					y1="700.82"
					x2="582.28"
					y2="712.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="673.89"
					y1="712.88"
					x2="677.5"
					y2="712.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="673.89"
					y1="700.82"
					x2="677.5"
					y2="700.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="673.89"
					y1="700.82"
					x2="673.89"
					y2="712.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="576.49"
					y1="712.88"
					x2="582.28"
					y2="712.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="582.28"
					y1="700.82"
					x2="576.49"
					y2="700.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<polyline
					points="672.68 714.08 677.5 714.08 677.5 712.88 672.68 712.88 672.68 714.08"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="583.49 712.88 578.67 712.88 578.67 714.08 583.49 714.08 583.49 712.88"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="672.68 700.82 677.5 700.82 677.5 699.62 672.68 699.62 672.68 700.82"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="583.49 699.62 578.67 699.62 578.67 700.82 583.49 700.82 583.49 699.62"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="672.68"
					y1="714.08"
					x2="677.5"
					y2="714.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="677.5"
					y1="714.08"
					x2="677.5"
					y2="712.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="677.5"
					y1="712.88"
					x2="672.68"
					y2="712.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="672.68"
					y1="712.88"
					x2="672.68"
					y2="714.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="583.49"
					y1="712.88"
					x2="578.67"
					y2="712.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="578.67"
					y1="712.88"
					x2="578.67"
					y2="714.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="578.67"
					y1="714.08"
					x2="583.49"
					y2="714.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="583.49"
					y1="714.08"
					x2="583.49"
					y2="712.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="672.68"
					y1="700.82"
					x2="677.5"
					y2="700.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="677.5"
					y1="700.82"
					x2="677.5"
					y2="699.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="677.5"
					y1="699.62"
					x2="672.68"
					y2="699.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="672.68"
					y1="699.62"
					x2="672.68"
					y2="700.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="583.49"
					y1="699.62"
					x2="578.67"
					y2="699.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="578.67"
					y1="699.62"
					x2="578.67"
					y2="700.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="578.67"
					y1="700.82"
					x2="583.49"
					y2="700.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="583.49"
					y1="700.82"
					x2="583.49"
					y2="699.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="671.48 712.88 673.28 712.88 673.28 700.82 671.48 700.82 671.48 712.88"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="582.89 712.88 584.69 712.88 584.69 700.82 582.89 700.82 582.89 712.88"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="646.06 639.46 584.69 700.82 587.68 703.8 649.04 642.44 646.06 639.46"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="673.28"
					y1="700.82"
					x2="673.89"
					y2="700.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="673.28"
					y1="712.88"
					x2="673.89"
					y2="712.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="673.89"
					y1="700.82"
					x2="673.89"
					y2="712.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="582.89"
					y1="700.82"
					x2="582.28"
					y2="700.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="582.89"
					y1="712.88"
					x2="582.28"
					y2="712.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="582.28"
					y1="700.82"
					x2="582.28"
					y2="712.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="671.48"
					y1="712.88"
					x2="671.48"
					y2="700.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="671.48"
					y1="700.82"
					x2="673.28"
					y2="700.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="673.28"
					y1="700.82"
					x2="673.28"
					y2="712.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="673.28"
					y1="712.88"
					x2="671.48"
					y2="712.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="582.89"
					y1="712.88"
					x2="582.89"
					y2="700.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="582.89"
					y1="700.82"
					x2="584.69"
					y2="700.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="584.69"
					y1="700.82"
					x2="584.69"
					y2="712.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="584.69"
					y1="712.88"
					x2="582.89"
					y2="712.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="646.06"
					y1="639.46"
					x2="649.04"
					y2="642.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="649.04"
					y1="642.44"
					x2="587.68"
					y2="703.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="587.68"
					y1="703.8"
					x2="584.69"
					y2="700.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="584.69"
					y1="700.82"
					x2="646.06"
					y2="639.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="673.89"
					y1="700.82"
					x2="673.89"
					y2="712.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="673.89"
					y1="700.82"
					x2="673.89"
					y2="712.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="673.89"
					y1="700.82"
					x2="677.5"
					y2="700.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="673.89"
					y1="700.82"
					x2="677.5"
					y2="700.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="673.89"
					y1="712.88"
					x2="677.5"
					y2="712.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="673.89"
					y1="712.88"
					x2="677.5"
					y2="712.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="582.28"
					y1="700.82"
					x2="582.28"
					y2="712.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="582.28"
					y1="700.82"
					x2="582.28"
					y2="712.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="582.28"
					y1="700.82"
					x2="578.67"
					y2="700.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="582.28"
					y1="700.82"
					x2="578.67"
					y2="700.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="582.28"
					y1="712.88"
					x2="578.67"
					y2="712.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="582.28"
					y1="712.88"
					x2="578.67"
					y2="712.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="764.47"
					y1="898.51"
					x2="764.47"
					y2="902.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="752.42"
					y1="898.51"
					x2="752.42"
					y2="902.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="752.42"
					y1="898.51"
					x2="764.47"
					y2="898.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="764.47"
					y1="831.01"
					x2="764.47"
					y2="827.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="752.42"
					y1="831.01"
					x2="752.42"
					y2="827.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="752.42"
					y1="831.01"
					x2="764.47"
					y2="831.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="752.42"
					y1="734.75"
					x2="764.47"
					y2="734.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="764.47"
					y1="802.25"
					x2="764.47"
					y2="805.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="752.42"
					y1="802.25"
					x2="752.42"
					y2="805.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="752.42"
					y1="802.25"
					x2="764.47"
					y2="802.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="752.42"
					y1="802.25"
					x2="752.42"
					y2="831.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="764.47"
					y1="831.01"
					x2="764.47"
					y2="826.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="764.47"
					y1="814.31"
					x2="764.47"
					y2="802.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<polyline
					points="765.67 832.22 765.67 827.4 764.47 827.4 764.47 832.22 765.67 832.22"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="764.47 897.31 764.47 902.13 765.67 902.13 765.67 897.31 764.47 897.31"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="752.42 832.22 752.42 827.4 751.21 827.4 751.21 832.22 752.42 832.22"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="751.21 897.31 751.21 902.13 752.42 902.13 752.42 897.31 751.21 897.31"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="765.67"
					y1="832.22"
					x2="765.67"
					y2="827.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="765.67"
					y1="827.4"
					x2="764.47"
					y2="827.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="764.47"
					y1="827.4"
					x2="764.47"
					y2="832.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="764.47"
					y1="832.22"
					x2="765.67"
					y2="832.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="764.47"
					y1="897.31"
					x2="764.47"
					y2="902.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="764.47"
					y1="902.13"
					x2="765.67"
					y2="902.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="765.67"
					y1="902.13"
					x2="765.67"
					y2="897.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="765.67"
					y1="897.31"
					x2="764.47"
					y2="897.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.42"
					y1="832.22"
					x2="752.42"
					y2="827.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.42"
					y1="827.4"
					x2="751.21"
					y2="827.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="751.21"
					y1="827.4"
					x2="751.21"
					y2="832.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="751.21"
					y1="832.22"
					x2="752.42"
					y2="832.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="751.21"
					y1="897.31"
					x2="751.21"
					y2="902.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="751.21"
					y1="902.13"
					x2="752.42"
					y2="902.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.42"
					y1="902.13"
					x2="752.42"
					y2="897.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.42"
					y1="897.31"
					x2="751.21"
					y2="897.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="764.47 833.42 764.47 831.62 752.42 831.62 752.42 833.42 764.47 833.42"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="764.47 897.91 764.47 896.1 752.42 896.1 752.42 897.91 764.47 897.91"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="708.1 851.78 752.42 896.1 755.4 893.12 711.08 848.8 708.1 851.78"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="752.42"
					y1="831.62"
					x2="752.42"
					y2="831.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="764.47"
					y1="831.62"
					x2="764.47"
					y2="831.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.42"
					y1="831.01"
					x2="764.47"
					y2="831.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.42"
					y1="897.91"
					x2="752.42"
					y2="898.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="764.47"
					y1="897.91"
					x2="764.47"
					y2="898.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.42"
					y1="898.51"
					x2="764.47"
					y2="898.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="764.47"
					y1="833.42"
					x2="752.42"
					y2="833.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.42"
					y1="833.42"
					x2="752.42"
					y2="831.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.42"
					y1="831.62"
					x2="764.47"
					y2="831.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="764.47"
					y1="831.62"
					x2="764.47"
					y2="833.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="764.47"
					y1="897.91"
					x2="752.42"
					y2="897.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.42"
					y1="897.91"
					x2="752.42"
					y2="896.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.42"
					y1="896.1"
					x2="764.47"
					y2="896.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="764.47"
					y1="896.1"
					x2="764.47"
					y2="897.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="708.1"
					y1="851.78"
					x2="711.08"
					y2="848.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="711.08"
					y1="848.8"
					x2="755.4"
					y2="893.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="755.4"
					y1="893.12"
					x2="752.42"
					y2="896.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.42"
					y1="896.1"
					x2="708.1"
					y2="851.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.42"
					y1="831.01"
					x2="764.47"
					y2="831.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="752.42"
					y1="831.01"
					x2="764.47"
					y2="831.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="752.42"
					y1="831.01"
					x2="752.42"
					y2="827.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="752.42"
					y1="831.01"
					x2="752.42"
					y2="827.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="764.47"
					y1="831.01"
					x2="764.47"
					y2="827.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="764.47"
					y1="831.01"
					x2="764.47"
					y2="827.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="752.42"
					y1="898.51"
					x2="764.47"
					y2="898.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="752.42"
					y1="898.51"
					x2="764.47"
					y2="898.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="752.42"
					y1="898.51"
					x2="752.42"
					y2="902.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="752.42"
					y1="898.51"
					x2="752.42"
					y2="902.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="764.47"
					y1="898.51"
					x2="764.47"
					y2="902.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="764.47"
					y1="898.51"
					x2="764.47"
					y2="902.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<polyline
					points="765.67 801.04 764.47 801.04 764.47 805.87 765.67 805.87 765.67 801.04"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="752.42 801.04 751.21 801.04 751.21 805.87 752.42 805.87 752.42 801.04"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="765.67"
					y1="801.04"
					x2="765.67"
					y2="805.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="765.67"
					y1="805.87"
					x2="764.47"
					y2="805.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="764.47"
					y1="805.87"
					x2="764.47"
					y2="801.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="764.47"
					y1="801.04"
					x2="765.67"
					y2="801.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="765.67"
					y1="735.96"
					x2="764.47"
					y2="735.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.42"
					y1="801.04"
					x2="752.42"
					y2="805.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.42"
					y1="805.87"
					x2="751.21"
					y2="805.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="751.21"
					y1="805.87"
					x2="751.21"
					y2="801.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="751.21"
					y1="801.04"
					x2="752.42"
					y2="801.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.42"
					y1="735.96"
					x2="751.21"
					y2="735.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="764.47 799.84 752.42 799.84 752.42 801.65 764.47 801.65 764.47 799.84"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="764.47 735.35 752.42 735.35 752.42 737.16 764.47 737.16 764.47 735.35"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="708.1 781.48 711.08 784.46 755.4 740.14 752.42 737.16 708.1 781.48"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="752.42"
					y1="801.65"
					x2="752.42"
					y2="802.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="764.47"
					y1="801.65"
					x2="764.47"
					y2="802.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.42"
					y1="802.25"
					x2="764.47"
					y2="802.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.42"
					y1="735.35"
					x2="752.42"
					y2="734.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="764.47"
					y1="735.35"
					x2="764.47"
					y2="734.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.42"
					y1="734.75"
					x2="764.47"
					y2="734.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="764.47"
					y1="799.84"
					x2="752.42"
					y2="799.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.42"
					y1="799.84"
					x2="752.42"
					y2="801.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.42"
					y1="801.65"
					x2="764.47"
					y2="801.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="764.47"
					y1="801.65"
					x2="764.47"
					y2="799.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="764.47"
					y1="735.35"
					x2="752.42"
					y2="735.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.42"
					y1="735.35"
					x2="752.42"
					y2="737.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.42"
					y1="737.16"
					x2="764.47"
					y2="737.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="764.47"
					y1="737.16"
					x2="764.47"
					y2="735.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="708.1"
					y1="781.48"
					x2="711.08"
					y2="784.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="711.08"
					y1="784.46"
					x2="755.4"
					y2="740.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="755.4"
					y1="740.14"
					x2="752.42"
					y2="737.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.42"
					y1="737.16"
					x2="708.1"
					y2="781.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.42"
					y1="802.25"
					x2="764.47"
					y2="802.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="752.42"
					y1="802.25"
					x2="764.47"
					y2="802.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="752.42"
					y1="802.25"
					x2="752.42"
					y2="805.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="752.42"
					y1="802.25"
					x2="752.42"
					y2="805.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="764.47"
					y1="802.25"
					x2="764.47"
					y2="805.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="764.47"
					y1="802.25"
					x2="764.47"
					y2="805.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="752.42"
					y1="734.75"
					x2="764.47"
					y2="734.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="752.42"
					y1="734.75"
					x2="764.47"
					y2="734.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="511.03"
					y1="164.83"
					x2="511.03"
					y2="152.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="511.03"
					y1="152.78"
					x2="511.03"
					y2="87.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="576.49"
					y1="535.8"
					x2="726.66"
					y2="535.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="726.66"
					y1="535.8"
					x2="726.66"
					y2="556.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="738.72"
					y1="544.71"
					x2="738.72"
					y2="535.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="726.66"
					y1="556.76"
					x2="738.72"
					y2="556.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="823.51"
					y1="761.7"
					x2="835.56"
					y2="761.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="835.56"
					y1="761.7"
					x2="840.58"
					y2="761.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="840.58"
					y1="749.65"
					x2="835.56"
					y2="749.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="223.01"
					y1="54.1"
					x2="222.06"
					y2="73.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="411.94"
					y1="63.43"
					x2="410.99"
					y2="82.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="511.03"
					y1="87.64"
					x2="542.82"
					y2="89.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="542.82"
					y1="89.21"
					x2="543.77"
					y2="69.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<polyline
					points="608.45 599.11 612.75 601.03 617.42 601.7 622.08 601.03 626.38 599.11 629.21 596.67 631.36 593.62 634.1 586.44 635.06 580.49 634.7 574.46 633.03 568.66 633.17 563.36 634.51 558.22 636.99 553.53 638.29 551.49 639.82 547.3 639.58 542.85 638.89 541.09 638.89 536.41 636.94 536.41 636.94 538.55 633.67 536.57 629.94 535.8 604.89 535.8 600.05 537.11 596.42 540.56 594.86 545.32 594.86 545.89 595.36 548.9 597.9 553.64 600.36 558.28 601.69 563.36 601.82 568.6 600.14 574.42 599.77 580.46 600.73 586.44 603.47 593.62 605.61 596.67 608.45 599.11"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="626.34"
					y1="558.06"
					x2="608.49"
					y2="558.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="604.89"
					y1="535.8"
					x2="617.42"
					y2="535.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="604.89"
					y1="536.71"
					x2="617.42"
					y2="536.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="629.94"
					y1="535.8"
					x2="617.42"
					y2="535.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="629.94"
					y1="536.71"
					x2="617.42"
					y2="536.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="608.95"
					y1="558.06"
					x2="608.95"
					y2="554.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="608.95"
					y1="554.73"
					x2="611.71"
					y2="554.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="611.71"
					y1="554.73"
					x2="611.71"
					y2="558.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="625.87"
					y1="558.06"
					x2="625.87"
					y2="554.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="625.87"
					y1="554.73"
					x2="623.12"
					y2="554.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="623.12"
					y1="554.73"
					x2="623.12"
					y2="558.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="636.94"
					y1="544.7"
					x2="636.94"
					y2="536.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="638.89"
					y1="544.7"
					x2="638.89"
					y2="536.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="638.89"
					y1="536.41"
					x2="636.94"
					y2="536.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="638.89"
					y1="544.7"
					x2="636.94"
					y2="544.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="617.42"
					y1="601.7"
					x2="614.43"
					y2="601.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="614.43"
					y1="601.35"
					x2="611.53"
					y2="600.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="611.53"
					y1="600.58"
					x2="608.45"
					y2="599.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="608.45"
					y1="599.11"
					x2="605.61"
					y2="596.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="605.61"
					y1="596.68"
					x2="603.47"
					y2="593.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="603.47"
					y1="593.62"
					x2="601.88"
					y2="590.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="601.88"
					y1="590.14"
					x2="600.73"
					y2="586.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="600.73"
					y1="586.44"
					x2="599.69"
					y2="580.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="599.69"
					y1="580.47"
					x2="599.64"
					y2="577.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="599.64"
					y1="577.46"
					x2="599.97"
					y2="574.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="599.97"
					y1="574.46"
					x2="601.33"
					y2="569.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="601.33"
					y1="569.81"
					x2="603.44"
					y2="565.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="603.44"
					y1="565.3"
					x2="605.95"
					y2="561.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="605.95"
					y1="561.28"
					x2="608.49"
					y2="558.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="601.82"
					y1="568.6"
					x2="601.8"
					y2="564.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="601.8"
					y1="564.42"
					x2="601.11"
					y2="560.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="601.11"
					y1="560.36"
					x2="600.4"
					y2="558.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="600.4"
					y1="558.17"
					x2="599.38"
					y2="556"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="599.38"
					y1="556"
					x2="597.36"
					y2="552.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="597.36"
					y1="552.84"
					x2="595.59"
					y2="549.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="595.59"
					y1="549.57"
					x2="594.88"
					y2="546.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="594.88"
					y1="546.38"
					x2="595.15"
					y2="543.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="595.15"
					y1="543.2"
					x2="596.39"
					y2="540.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="596.39"
					y1="540.31"
					x2="597.36"
					y2="539.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="597.36"
					y1="539.06"
					x2="598.58"
					y2="537.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="598.58"
					y1="537.98"
					x2="600.71"
					y2="536.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="600.71"
					y1="536.8"
					x2="602.76"
					y2="536.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="602.76"
					y1="536.14"
					x2="604.89"
					y2="535.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="604.89"
					y1="536.71"
					x2="603.94"
					y2="536.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="603.94"
					y1="536.8"
					x2="601.97"
					y2="537.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="601.97"
					y1="537.41"
					x2="600.23"
					y2="538.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="600.23"
					y1="538.88"
					x2="599.14"
					y2="540.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="599.14"
					y1="540.91"
					x2="598.62"
					y2="543.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="598.62"
					y1="543.6"
					x2="598.5"
					y2="546.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="598.5"
					y1="546.37"
					x2="598.52"
					y2="547.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="598.52"
					y1="547.75"
					x2="599.1"
					y2="548.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="599.1"
					y1="548.84"
					x2="599.78"
					y2="549.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="599.78"
					y1="549.16"
					x2="607.35"
					y2="551.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="607.35"
					y1="551.31"
					x2="611.12"
					y2="551.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="611.12"
					y1="551.95"
					x2="614.93"
					y2="552.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="614.93"
					y1="552.23"
					x2="617.42"
					y2="552.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="633.03"
					y1="568.66"
					x2="633.06"
					y2="564.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="633.06"
					y1="564.47"
					x2="633.75"
					y2="560.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="633.75"
					y1="560.38"
					x2="634.44"
					y2="558.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="634.44"
					y1="558.18"
					x2="635.45"
					y2="556"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="635.45"
					y1="556"
					x2="637.45"
					y2="552.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="637.45"
					y1="552.83"
					x2="639.24"
					y2="549.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="639.24"
					y1="549.57"
					x2="639.82"
					y2="547.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="639.82"
					y1="547.44"
					x2="639.96"
					y2="545.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="639.96"
					y1="545.25"
					x2="639.65"
					y2="543.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="639.65"
					y1="543.1"
					x2="638.89"
					y2="541.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="629.94"
					y1="536.71"
					x2="630.89"
					y2="536.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="630.89"
					y1="536.8"
					x2="632.86"
					y2="537.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="632.86"
					y1="537.41"
					x2="634.6"
					y2="538.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="634.6"
					y1="538.88"
					x2="635.69"
					y2="540.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="635.69"
					y1="540.91"
					x2="636.21"
					y2="543.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="636.21"
					y1="543.6"
					x2="636.33"
					y2="546.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="636.33"
					y1="546.37"
					x2="636.31"
					y2="547.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="636.31"
					y1="547.75"
					x2="635.73"
					y2="548.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="635.73"
					y1="548.84"
					x2="635.05"
					y2="549.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="635.05"
					y1="549.16"
					x2="627.48"
					y2="551.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="627.48"
					y1="551.31"
					x2="623.71"
					y2="551.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="623.71"
					y1="551.95"
					x2="619.9"
					y2="552.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="619.9"
					y1="552.23"
					x2="617.42"
					y2="552.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="617.42"
					y1="601.7"
					x2="620.41"
					y2="601.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="620.41"
					y1="601.35"
					x2="623.3"
					y2="600.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="623.3"
					y1="600.58"
					x2="626.38"
					y2="599.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="626.38"
					y1="599.11"
					x2="629.22"
					y2="596.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="629.22"
					y1="596.68"
					x2="631.36"
					y2="593.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="631.36"
					y1="593.62"
					x2="632.95"
					y2="590.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="632.95"
					y1="590.14"
					x2="634.1"
					y2="586.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="634.1"
					y1="586.44"
					x2="635.14"
					y2="580.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="635.14"
					y1="580.47"
					x2="635.19"
					y2="577.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="635.19"
					y1="577.46"
					x2="634.85"
					y2="574.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="634.85"
					y1="574.46"
					x2="633.5"
					y2="569.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="633.5"
					y1="569.81"
					x2="631.39"
					y2="565.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="631.39"
					y1="565.3"
					x2="628.88"
					y2="561.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="628.88"
					y1="561.28"
					x2="626.34"
					y2="558.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="596.43"
					y1="551.31"
					x2="596.91"
					y2="551.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="596.91"
					y1="551.99"
					x2="598.29"
					y2="553.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="598.29"
					y1="553.01"
					x2="599.48"
					y2="553.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="599.48"
					y1="553.25"
					x2="607.18"
					y2="553.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="607.18"
					y1="553.9"
					x2="614.89"
					y2="554.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="614.89"
					y1="554.2"
					x2="617.42"
					y2="554.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="638.4"
					y1="551.31"
					x2="637.92"
					y2="551.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="637.92"
					y1="551.99"
					x2="636.54"
					y2="553.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="636.54"
					y1="553.01"
					x2="635.34"
					y2="553.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="635.34"
					y1="553.25"
					x2="627.65"
					y2="553.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="627.65"
					y1="553.9"
					x2="619.94"
					y2="554.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="619.94"
					y1="554.2"
					x2="617.42"
					y2="554.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="636.94"
					y1="538.55"
					x2="636.25"
					y2="537.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="636.25"
					y1="537.98"
					x2="634.12"
					y2="536.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="634.12"
					y1="536.8"
					x2="632.07"
					y2="536.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="632.07"
					y1="536.14"
					x2="629.94"
					y2="535.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="588.49 535.8 588.49 536.77 593.31 536.77 593.31 535.8 588.49 535.8"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="593.31"
					y1="535.8"
					x2="588.49"
					y2="535.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="593.31"
					y1="536.77"
					x2="593.31"
					y2="535.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="588.49"
					y1="536.77"
					x2="593.31"
					y2="536.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="588.49"
					y1="535.8"
					x2="588.49"
					y2="536.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="646.34 535.8 641.52 535.8 641.52 536.77 646.34 536.77 646.34 535.8"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="646.34"
					y1="536.77"
					x2="646.34"
					y2="535.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="641.52"
					y1="536.77"
					x2="646.34"
					y2="536.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="641.52"
					y1="535.8"
					x2="641.52"
					y2="536.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="646.34"
					y1="535.8"
					x2="641.52"
					y2="535.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="590.42 536.77 590.42 544.61 591.38 544.61 591.38 536.77 590.42 536.77"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="591.38"
					y1="536.77"
					x2="590.42"
					y2="536.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="591.38"
					y1="544.61"
					x2="591.38"
					y2="536.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="590.42"
					y1="544.61"
					x2="591.38"
					y2="544.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="590.42"
					y1="536.77"
					x2="590.42"
					y2="544.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="644.41 536.77 643.45 536.77 643.45 544.61 644.41 544.61 644.41 536.77"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="644.41"
					y1="544.61"
					x2="644.41"
					y2="536.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="643.45"
					y1="544.61"
					x2="644.41"
					y2="544.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="643.45"
					y1="536.77"
					x2="643.45"
					y2="544.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="644.41"
					y1="536.77"
					x2="643.45"
					y2="536.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="591.38 542.2 591.38 544.13 643.45 544.13 643.45 542.2 591.38 542.2"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="643.45"
					y1="542.2"
					x2="591.38"
					y2="542.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="643.45"
					y1="544.13"
					x2="643.45"
					y2="542.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="591.38"
					y1="544.13"
					x2="643.45"
					y2="544.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="591.38"
					y1="542.2"
					x2="591.38"
					y2="544.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="726.66"
					y1="700.82"
					x2="798.08"
					y2="700.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="726.66"
					y1="556.76"
					x2="726.66"
					y2="700.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="789.62 565.79 736.06 565.79 736.06 691.18 789.62 691.18 789.62 565.79"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="789.62"
					y1="691.18"
					x2="789.62"
					y2="565.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.06"
					y1="691.18"
					x2="789.62"
					y2="691.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.06"
					y1="565.79"
					x2="736.06"
					y2="691.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="789.62"
					y1="565.79"
					x2="736.06"
					y2="565.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="762.37 578.11 762.85 578.07 763.32 577.94 763.76 577.74 764.15 577.46 764.49 577.13 764.77 576.73 764.97 576.3 765.1 575.84 765.14 575.36 765.1 574.88 764.97 574.42 764.77 573.98 764.49 573.59 764.15 573.25 763.76 572.98 763.32 572.77 762.85 572.65 762.37 572.61 761.89 572.65 761.43 572.77 760.99 572.98 760.59 573.25 760.25 573.59 759.97 573.98 759.77 574.42 759.64 574.88 759.6 575.36 759.64 575.84 759.77 576.3 759.97 576.73 760.25 577.13 760.59 577.46 760.99 577.74 761.43 577.94 761.89 578.07 762.37 578.11"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="761.89"
					y1="578.07"
					x2="762.37"
					y2="578.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="761.43"
					y1="577.94"
					x2="761.89"
					y2="578.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="760.99"
					y1="577.74"
					x2="761.43"
					y2="577.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="760.59"
					y1="577.46"
					x2="760.99"
					y2="577.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="760.25"
					y1="577.13"
					x2="760.59"
					y2="577.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="759.97"
					y1="576.73"
					x2="760.25"
					y2="577.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="759.77"
					y1="576.3"
					x2="759.97"
					y2="576.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="759.64"
					y1="575.84"
					x2="759.77"
					y2="576.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="759.6"
					y1="575.36"
					x2="759.64"
					y2="575.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="759.64"
					y1="574.88"
					x2="759.6"
					y2="575.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="759.77"
					y1="574.42"
					x2="759.64"
					y2="574.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="759.97"
					y1="573.98"
					x2="759.77"
					y2="574.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="760.25"
					y1="573.59"
					x2="759.97"
					y2="573.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="760.59"
					y1="573.25"
					x2="760.25"
					y2="573.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="760.99"
					y1="572.98"
					x2="760.59"
					y2="573.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="761.43"
					y1="572.77"
					x2="760.99"
					y2="572.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="761.89"
					y1="572.65"
					x2="761.43"
					y2="572.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="762.37"
					y1="572.61"
					x2="761.89"
					y2="572.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="762.85"
					y1="572.65"
					x2="762.37"
					y2="572.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="763.32"
					y1="572.77"
					x2="762.85"
					y2="572.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="763.76"
					y1="572.98"
					x2="763.32"
					y2="572.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="764.15"
					y1="573.25"
					x2="763.76"
					y2="572.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="764.49"
					y1="573.59"
					x2="764.15"
					y2="573.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="764.77"
					y1="573.98"
					x2="764.49"
					y2="573.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="764.97"
					y1="574.42"
					x2="764.77"
					y2="573.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="765.1"
					y1="574.88"
					x2="764.97"
					y2="574.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="765.14"
					y1="575.36"
					x2="765.1"
					y2="574.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="765.1"
					y1="575.84"
					x2="765.14"
					y2="575.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="764.97"
					y1="576.3"
					x2="765.1"
					y2="575.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="764.77"
					y1="576.73"
					x2="764.97"
					y2="576.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="764.49"
					y1="577.13"
					x2="764.77"
					y2="576.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="764.15"
					y1="577.46"
					x2="764.49"
					y2="577.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="763.76"
					y1="577.74"
					x2="764.15"
					y2="577.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="763.32"
					y1="577.94"
					x2="763.76"
					y2="577.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="762.85"
					y1="578.07"
					x2="763.32"
					y2="577.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="762.37"
					y1="578.11"
					x2="762.85"
					y2="578.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="759.98 562.57 760.02 562.16 760.13 561.76 760.3 561.38 760.54 561.04 760.84 560.75 761.18 560.51 761.55 560.34 761.96 560.23 762.37 560.2 762.79 560.23 763.19 560.34 763.57 560.51 763.91 560.75 764.2 561.04 764.44 561.38 764.62 561.76 764.72 562.16 764.76 562.57 764.38 566.55 764.32 566.87 764.22 567.17 764.06 567.45 763.43 572.48 763.39 572.66 763.33 572.83 763.23 572.98 763.11 573.11 762.97 573.23 762.81 573.32 762.64 573.37 762.46 573.4 762.28 573.4 762.1 573.37 761.93 573.31 761.77 573.23 761.63 573.11 761.51 572.98 761.42 572.83 761.35 572.66 761.31 572.48 760.68 567.45 760.52 567.17 760.42 566.87 760.36 566.55 759.98 562.57"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="759.98"
					y1="562.57"
					x2="760.36"
					y2="566.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="760.68"
					y1="567.45"
					x2="761.31"
					y2="572.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="763.43"
					y1="572.48"
					x2="764.06"
					y2="567.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="764.38"
					y1="566.55"
					x2="764.76"
					y2="562.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="763.67"
					y1="564.93"
					x2="763.67"
					y2="566.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="761.07"
					y1="566.34"
					x2="761.07"
					y2="564.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="761.07"
					y1="564.93"
					x2="763.67"
					y2="564.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m760.68,567.45c-.18-.27-.28-.58-.31-.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m763.43,572.48c-.07.53-.52.93-1.06.93s-.99-.4-1.06-.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m764.38,566.55c-.03.32-.14.63-.31.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m759.98,562.57c0-1.31,1.07-2.37,2.39-2.37s2.39,1.06,2.39,2.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m763.67,566.34c0,.71-.58,1.29-1.3,1.29s-1.3-.58-1.3-1.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m764.06,567.45c-.37.57-1.01.92-1.69.92s-1.32-.35-1.69-.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="234.43 584.06 179.42 584.06 179.42 530 234.43 530 234.43 584.06"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="234.43"
					y1="584.06"
					x2="231.81"
					y2="584.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="228.33"
					y1="584.06"
					x2="222.55"
					y2="584.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="219.08"
					y1="584.06"
					x2="213.29"
					y2="584.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="209.82"
					y1="584.06"
					x2="204.03"
					y2="584.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="200.56"
					y1="584.06"
					x2="194.78"
					y2="584.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="191.31"
					y1="584.06"
					x2="185.52"
					y2="584.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="182.05"
					y1="584.06"
					x2="179.42"
					y2="584.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="179.42"
					y1="584.06"
					x2="179.42"
					y2="581.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="179.42"
					y1="578.44"
					x2="179.42"
					y2="572.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="179.42"
					y1="569.18"
					x2="179.42"
					y2="563.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="179.42"
					y1="559.92"
					x2="179.42"
					y2="554.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="179.42"
					y1="550.67"
					x2="179.42"
					y2="544.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="179.42"
					y1="541.41"
					x2="179.42"
					y2="535.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="179.42"
					y1="532.15"
					x2="179.42"
					y2="530"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="179.42"
					y1="530"
					x2="182.05"
					y2="530"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="185.52"
					y1="530"
					x2="191.31"
					y2="530"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="194.78"
					y1="530"
					x2="200.56"
					y2="530"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="204.03"
					y1="530"
					x2="209.82"
					y2="530"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="213.29"
					y1="530"
					x2="219.08"
					y2="530"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="222.55"
					y1="530"
					x2="228.33"
					y2="530"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="231.81"
					y1="530"
					x2="234.43"
					y2="530"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="234.43"
					y1="530"
					x2="234.43"
					y2="532.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="234.43"
					y1="535.62"
					x2="234.43"
					y2="541.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="234.43"
					y1="544.88"
					x2="234.43"
					y2="550.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="234.43"
					y1="554.14"
					x2="234.43"
					y2="559.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="234.43"
					y1="563.39"
					x2="234.43"
					y2="569.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="234.43"
					y1="572.65"
					x2="234.43"
					y2="578.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="234.43"
					y1="581.91"
					x2="234.43"
					y2="584.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="237.28 530.21 238.94 530.21 238.94 583.86 237.28 583.86 237.28 575.44 238.64 575.44 238.64 538.62 237.28 538.62 237.28 530.21"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="237.28"
					y1="530.21"
					x2="238.94"
					y2="530.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="238.94"
					y1="530.21"
					x2="238.94"
					y2="583.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="238.94"
					y1="583.86"
					x2="237.28"
					y2="583.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="237.28"
					y1="583.86"
					x2="237.28"
					y2="575.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="237.28"
					y1="575.44"
					x2="238.64"
					y2="575.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="238.64"
					y1="575.44"
					x2="238.64"
					y2="538.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="238.64"
					y1="538.62"
					x2="237.28"
					y2="538.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="237.28"
					y1="538.62"
					x2="237.28"
					y2="530.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<polyline
					points="237.28 528.1 237.28 585.96 234.43 585.96 234.43 528.1 237.28 528.1"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="237.28"
					y1="528.1"
					x2="237.28"
					y2="585.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="237.28"
					y1="585.96"
					x2="234.43"
					y2="585.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="234.43"
					y1="585.96"
					x2="234.43"
					y2="528.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="234.43"
					y1="528.1"
					x2="237.28"
					y2="528.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="237.28"
					y1="583.86"
					x2="238.94"
					y2="583.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="238.94"
					y1="583.86"
					x2="238.94"
					y2="530.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="238.94"
					y1="530.21"
					x2="237.28"
					y2="530.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="237.28"
					y1="585.96"
					x2="237.28"
					y2="528.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="237.28"
					y1="538.62"
					x2="238.64"
					y2="538.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="238.64"
					y1="538.62"
					x2="238.64"
					y2="575.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="238.64"
					y1="575.44"
					x2="237.28"
					y2="575.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="234.43"
					y1="585.96"
					x2="237.28"
					y2="585.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="237.28"
					y1="528.1"
					x2="234.43"
					y2="528.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="234.43"
					y1="528.1"
					x2="234.43"
					y2="585.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="445.51 677.84 364 677.84 364 766.39 445.51 766.39 445.51 677.84"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="445.51"
					y1="766.39"
					x2="445.51"
					y2="677.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="364"
					y1="766.39"
					x2="445.51"
					y2="766.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="364"
					y1="677.84"
					x2="364"
					y2="766.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="445.51"
					y1="677.84"
					x2="364"
					y2="677.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="445.51"
					y1="683.87"
					x2="364"
					y2="683.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="339.02 682 266.7 682 266.7 744.68 339.02 744.68 339.02 682"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="339.02"
					y1="682"
					x2="266.7"
					y2="682"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.02"
					y1="744.68"
					x2="266.7"
					y2="744.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.02"
					y1="742.78"
					x2="266.7"
					y2="742.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.02"
					y1="682"
					x2="339.02"
					y2="744.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="266.7"
					y1="682"
					x2="266.7"
					y2="744.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="334.28"
					y1="684.85"
					x2="271.45"
					y2="684.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="271.45"
					y1="684.85"
					x2="269.55"
					y2="686.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="269.55"
					y1="686.74"
					x2="269.55"
					y2="739.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="269.55"
					y1="739.93"
					x2="271.45"
					y2="741.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="271.45"
					y1="741.83"
					x2="334.28"
					y2="741.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="334.28"
					y1="741.83"
					x2="336.17"
					y2="739.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="336.17"
					y1="739.93"
					x2="336.17"
					y2="686.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="336.17"
					y1="686.74"
					x2="334.28"
					y2="684.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m330.43,697.67c0-5.24-4.25-9.49-9.49-9.49s-9.49,4.25-9.49,9.49,4.25,9.49,9.49,9.49,9.49-4.25,9.49-9.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m328.06,729.01c0-3.93-3.19-7.12-7.12-7.12s-7.12,3.19-7.12,7.12,3.19,7.12,7.12,7.12,7.12-3.19,7.12-7.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m291.9,697.67c0-3.93-3.19-7.12-7.12-7.12s-7.12,3.19-7.12,7.12,3.19,7.12,7.12,7.12,7.12-3.19,7.12-7.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m294.27,729.01c0-5.24-4.25-9.49-9.49-9.49s-9.49,4.25-9.49,9.49,4.25,9.49,9.49,9.49,9.49-4.25,9.49-9.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="230.35 592.47 230.35 652.53 230.09 653.47 229.4 654.17 228.45 654.42 188.25 654.42 187.3 654.17 186.61 653.47 186.35 652.53 186.35 592.47 186.61 591.53 187.3 590.83 188.25 590.58 228.45 590.58 229.4 590.83 230.09 591.53 230.35 592.47"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="230.35"
					y1="592.47"
					x2="230.35"
					y2="652.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m230.35,652.53c0,1.05-.85,1.9-1.9,1.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="228.45"
					y1="654.42"
					x2="188.25"
					y2="654.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m188.25,654.42c-1.05,0-1.9-.85-1.9-1.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="186.35"
					y1="652.53"
					x2="186.35"
					y2="592.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m186.35,592.47c0-1.05.85-1.9,1.9-1.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="188.25"
					y1="590.58"
					x2="228.45"
					y2="590.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m228.45,590.58c1.05,0,1.9.85,1.9,1.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="225.6"
					y1="597.22"
					x2="225.6"
					y2="647.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="223.7"
					y1="649.68"
					x2="197.74"
					y2="649.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="195.84"
					y1="647.78"
					x2="195.84"
					y2="597.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="197.74"
					y1="595.32"
					x2="223.7"
					y2="595.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="225.6"
					y1="597.22"
					x2="225.6"
					y2="597.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m225.6,647.78c0,1.05-.85,1.9-1.9,1.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m197.74,649.68c-1.05,0-1.9-.85-1.9-1.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m195.84,597.22c0-1.05.85-1.9,1.9-1.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m223.7,595.32c1.05,0,1.9.85,1.9,1.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m208.18,622.5c0-1.58-1.27-2.85-2.85-2.85s-2.85,1.27-2.85,2.85,1.27,2.85,2.85,2.85,2.85-1.27,2.85-2.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="207.98 621.65 208.59 621.9 208.83 622.5 208.58 623.1 207.98 623.35 189.2 623.35 188.6 623.1 188.35 622.5 188.6 621.9 189.2 621.65 207.98 621.65"
					fill="none"
					fillRule="evenodd"
				/>
				<path
					d="m207.98,621.65c.47,0,.85.38.85.86s-.38.85-.85.85h0"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="207.98"
					y1="623.35"
					x2="189.2"
					y2="623.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m189.2,623.35c-.47,0-.85-.38-.85-.85s.38-.86.85-.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="189.2"
					y1="621.65"
					x2="207.98"
					y2="621.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="194.04 620.61 194.04 621.65 189.2 621.65 188.6 621.9 188.35 622.5 188.6 623.1 189.2 623.35 194.04 623.35 194.04 624.39 187.87 624.39 187.87 620.61 194.04 620.61"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="194.04"
					y1="620.61"
					x2="194.04"
					y2="621.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="194.04"
					y1="621.65"
					x2="189.2"
					y2="621.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m189.2,623.35c-.47,0-.85-.38-.85-.85s.38-.86.85-.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="189.2"
					y1="623.35"
					x2="194.04"
					y2="623.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="194.04"
					y1="623.35"
					x2="194.04"
					y2="624.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="194.04"
					y1="624.39"
					x2="187.87"
					y2="624.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="187.87"
					y1="624.39"
					x2="187.87"
					y2="620.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="187.87"
					y1="620.61"
					x2="194.04"
					y2="620.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="197.46 620.63 197.46 621.65 194.14 621.65 194.14 620.63 197.46 620.63"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="197.46"
					y1="620.63"
					x2="197.46"
					y2="621.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="197.46"
					y1="621.65"
					x2="194.14"
					y2="621.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="194.14"
					y1="621.65"
					x2="194.14"
					y2="620.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="194.14"
					y1="620.63"
					x2="197.46"
					y2="620.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="197.46 624.37 194.14 624.37 194.14 623.35 197.46 623.35 197.46 624.37"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="197.46"
					y1="624.37"
					x2="194.14"
					y2="624.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="194.14"
					y1="624.37"
					x2="194.14"
					y2="623.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="194.14"
					y1="623.35"
					x2="197.46"
					y2="623.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="197.46"
					y1="623.35"
					x2="197.46"
					y2="624.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="659.95 583.99 722.63 583.99 722.63 535.8 659.95 535.8 659.95 583.99"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="659.95"
					y1="583.99"
					x2="722.63"
					y2="583.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="659.95"
					y1="535.8"
					x2="722.63"
					y2="535.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="722.63"
					y1="583.99"
					x2="722.63"
					y2="535.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="659.95"
					y1="583.99"
					x2="659.95"
					y2="535.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="659.95"
					y1="537.7"
					x2="722.63"
					y2="537.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="667.19"
					y1="572.56"
					x2="715.4"
					y2="572.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="715.4"
					y1="572.56"
					x2="715.4"
					y2="543.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="715.4"
					y1="543.63"
					x2="667.19"
					y2="543.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="667.19"
					y1="543.63"
					x2="667.19"
					y2="572.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="665.29"
					y1="574.45"
					x2="717.3"
					y2="574.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="717.3"
					y1="574.45"
					x2="717.3"
					y2="541.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="717.3"
					y1="541.73"
					x2="665.29"
					y2="541.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="665.29"
					y1="541.73"
					x2="665.29"
					y2="574.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m694.14,550.16c0-1.57-1.28-2.85-2.85-2.85s-2.85,1.28-2.85,2.85,1.28,2.85,2.85,2.85,2.85-1.28,2.85-2.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="688.92 538.41 689.3 542.39 689.61 543.29 690.24 548.32 690.59 548.98 691.29 549.25 692 548.98 692.35 548.32 692.98 543.29 693.29 542.39 693.67 538.41 693.21 537.01 692.03 536.15 690.56 536.15 689.37 537.01 688.92 538.41"
					fill="none"
					fillRule="evenodd"
				/>
				<path
					d="m688.92,538.41c0-1.31,1.06-2.37,2.37-2.37s2.37,1.06,2.37,2.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="693.29"
					y1="542.39"
					x2="693.67"
					y2="538.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m693.29,542.39c-.03.32-.13.63-.31.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="692.35"
					y1="548.32"
					x2="692.98"
					y2="543.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m692.35,548.32c-.07.53-.52.93-1.05.93s-.99-.4-1.05-.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="689.61"
					y1="543.29"
					x2="690.24"
					y2="548.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m689.61,543.29c-.18-.27-.28-.58-.31-.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="688.92"
					y1="538.41"
					x2="689.3"
					y2="542.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="692.58"
					y1="540.77"
					x2="692.58"
					y2="542.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="690"
					y1="542.18"
					x2="690"
					y2="540.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="690"
					y1="540.77"
					x2="692.58"
					y2="540.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m692.58,542.18c0,.71-.58,1.29-1.29,1.29s-1.29-.58-1.29-1.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m692.98,543.29c-.37.57-1,.92-1.68.92s-1.31-.35-1.68-.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="223.01"
					y1="54.1"
					x2="411.94"
					y2="63.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="410.99"
					y1="82.69"
					x2="222.06"
					y2="73.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="542.82"
					y1="89.21"
					x2="701.08"
					y2="97.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="702.03"
					y1="77.77"
					x2="543.77"
					y2="69.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="366.72"
					y1="677.84"
					x2="366.72"
					y2="672.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="366.72"
					y1="672.47"
					x2="369.43"
					y2="672.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="369.43"
					y1="672.47"
					x2="369.43"
					y2="677.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="445.51"
					y1="686.82"
					x2="443.52"
					y2="686.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="440.05"
					y1="686.82"
					x2="434.26"
					y2="686.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="430.79"
					y1="686.82"
					x2="425"
					y2="686.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="421.53"
					y1="686.82"
					x2="415.75"
					y2="686.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="412.28"
					y1="686.82"
					x2="406.49"
					y2="686.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="403.02"
					y1="686.82"
					x2="397.23"
					y2="686.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="393.76"
					y1="686.82"
					x2="387.98"
					y2="686.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="384.51"
					y1="686.82"
					x2="378.72"
					y2="686.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="375.25"
					y1="686.82"
					x2="369.46"
					y2="686.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="365.99"
					y1="686.82"
					x2="364"
					y2="686.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="237.28"
					y1="447.17"
					x2="179.42"
					y2="447.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="237.28"
					y1="528.1"
					x2="179.42"
					y2="528.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="364"
					y1="715.75"
					x2="361.97"
					y2="715.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="358.5"
					y1="715.75"
					x2="352.71"
					y2="715.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="349.24"
					y1="715.75"
					x2="343.45"
					y2="715.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.98"
					y1="715.75"
					x2="334.2"
					y2="715.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="330.72"
					y1="715.75"
					x2="324.94"
					y2="715.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="321.47"
					y1="715.75"
					x2="315.68"
					y2="715.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="312.21"
					y1="715.75"
					x2="306.43"
					y2="715.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="302.95"
					y1="715.75"
					x2="297.17"
					y2="715.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="293.7"
					y1="715.75"
					x2="287.91"
					y2="715.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="284.44"
					y1="715.75"
					x2="278.65"
					y2="715.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="275.18"
					y1="715.75"
					x2="269.4"
					y2="715.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="265.93"
					y1="715.75"
					x2="260.14"
					y2="715.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="256.67"
					y1="715.75"
					x2="250.88"
					y2="715.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="247.41"
					y1="715.75"
					x2="241.63"
					y2="715.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="238.15"
					y1="715.75"
					x2="232.37"
					y2="715.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="228.9"
					y1="715.75"
					x2="223.11"
					y2="715.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="219.64"
					y1="715.75"
					x2="213.86"
					y2="715.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="210.38"
					y1="715.75"
					x2="208.35"
					y2="715.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="208.35"
					y1="715.75"
					x2="208.35"
					y2="711.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="208.35"
					y1="708.13"
					x2="208.35"
					y2="702.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="208.35"
					y1="698.87"
					x2="208.35"
					y2="693.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="208.35"
					y1="689.62"
					x2="208.35"
					y2="683.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="208.35"
					y1="680.36"
					x2="208.35"
					y2="674.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="208.35"
					y1="671.1"
					x2="208.35"
					y2="665.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="208.35"
					y1="661.85"
					x2="208.35"
					y2="656.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="208.35"
					y1="652.59"
					x2="208.35"
					y2="646.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="208.35"
					y1="643.33"
					x2="208.35"
					y2="637.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="208.35"
					y1="634.07"
					x2="208.35"
					y2="628.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="208.35"
					y1="624.82"
					x2="208.35"
					y2="619.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="208.35"
					y1="615.56"
					x2="208.35"
					y2="609.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="208.35"
					y1="606.3"
					x2="208.35"
					y2="600.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="208.35"
					y1="597.05"
					x2="208.35"
					y2="591.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="208.35"
					y1="587.79"
					x2="208.35"
					y2="582"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="208.35"
					y1="578.53"
					x2="208.35"
					y2="572.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="208.35"
					y1="569.28"
					x2="208.35"
					y2="563.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="208.35"
					y1="560.02"
					x2="208.35"
					y2="554.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="208.35"
					y1="550.76"
					x2="208.35"
					y2="544.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="208.35"
					y1="541.51"
					x2="208.35"
					y2="535.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="208.35"
					y1="532.25"
					x2="208.35"
					y2="528.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
			</g>
			<g id="walls">
				<polygon
					points="859.87 688.2 859.87 950 840.58 949.1 708.18 942.9 709.08 923.63 752.41 925.67 752.41 898.51 764.47 898.51 764.47 926.22 818.46 928.76 818.46 826.37 764.47 826.37 764.47 831.01 752.41 831.01 752.41 802.24 764.47 802.24 764.47 814.31 840.58 814.31 840.58 761.7 823.51 761.7 823.51 712.88 764.47 712.88 764.47 734.76 752.41 734.76 752.41 712.88 673.89 712.88 673.89 700.82 798.08 700.82 798.08 556.77 726.67 556.77 726.67 535.8 576.49 535.8 576.49 700.82 582.29 700.82 582.29 712.88 564.43 712.88 564.43 554.21 549.97 554.21 549.97 542.16 564.43 542.16 564.43 435.27 587.41 435.27 587.41 447.32 576.49 447.32 576.49 502.9 744.12 502.9 744.12 447.32 728.43 447.32 728.43 435.27 744.12 435.27 744.12 144.69 731.93 144.69 731.93 98.56 701.08 97.03 702.03 77.77 744.12 79.84 763.4 80.8 763.4 483.61 817.37 483.61 817.37 688.2 859.87 688.2"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.11"
				/>
				<polygon
					points="617.58 919.36 616.67 938.61 612.51 938.42 593.22 937.52 593.22 847.03 426.22 847.03 426.22 785.68 140.13 785.68 140.13 50 159.42 50.96 223.01 54.1 222.06 73.36 159.42 70.27 159.42 447.17 179.42 447.17 179.42 744.68 364 744.68 364 766.39 445.51 766.39 445.51 827.76 612.51 827.76 612.51 919.11 617.58 919.36"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.11"
				/>
				<polygon
					points="543.77 69.94 542.81 89.21 511.03 87.63 511.03 164.83 453.3 164.83 453.3 542.16 458.36 542.16 458.36 554.21 366.79 554.21 366.79 426.17 441.24 426.17 441.24 84.19 410.99 82.69 411.94 63.43 543.77 69.94"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.11"
				/>
			</g>
			<g id="text">
				<path d="m181.31,562.07v-11.18h3.85c.87,0,1.53.05,1.99.16.64.15,1.19.41,1.64.8.59.5,1.03,1.14,1.32,1.91.29.77.44,1.66.44,2.65,0,.85-.1,1.6-.3,2.26s-.45,1.2-.76,1.63c-.31.43-.65.77-1.02,1.01-.37.24-.81.43-1.34.56-.52.13-1.12.19-1.79.19h-4.04Zm1.48-1.32h2.39c.74,0,1.31-.07,1.73-.21.42-.14.76-.33,1.01-.58.35-.35.62-.82.82-1.41.2-.6.3-1.31.3-2.16,0-1.17-.19-2.07-.58-2.69-.38-.63-.85-1.05-1.4-1.27-.4-.15-1.03-.23-1.91-.23h-2.35v8.54Zm11.76,1.32l-2.97-11.18h1.52l1.7,7.33c.18.77.34,1.53.47,2.29.28-1.2.45-1.88.5-2.07l2.13-7.55h1.79l1.6,5.66c.4,1.4.69,2.72.87,3.96.14-.71.33-1.52.56-2.43l1.75-7.19h1.49l-3.07,11.18h-1.43l-2.36-8.52c-.2-.71-.32-1.15-.35-1.31-.12.51-.23.95-.33,1.31l-2.37,8.52h-1.51Z" />
				<path d="m401.22,728.82h-1.57l-1.88-3.16c-.17-.29-.34-.54-.5-.75-.16-.21-.33-.38-.5-.51-.17-.13-.35-.22-.55-.28-.19-.06-.41-.09-.66-.09h-1.08v4.79h-1.32v-11.26h3.36c.49,0,.94.06,1.36.19.42.12.78.31,1.08.56.31.25.55.57.72.94.17.37.26.81.26,1.31,0,.39-.06.75-.18,1.08-.12.32-.28.61-.5.87-.21.26-.48.48-.78.66-.3.18-.65.32-1.03.42v.03c.19.08.35.18.49.29.14.1.27.23.4.38.13.15.25.31.37.5.13.18.26.4.42.64l2.11,3.38Zm-6.75-10.06v4.08h1.79c.33,0,.63-.05.91-.15.28-.1.53-.24.73-.42.2-.19.36-.42.48-.68.12-.27.17-.58.17-.91,0-.6-.2-1.07-.59-1.41-.39-.34-.95-.51-1.69-.51h-1.81Zm14.44,6.37h-5.68c.02.89.26,1.59.72,2.07s1.09.73,1.9.73c.91,0,1.74-.3,2.5-.89v1.21c-.71.51-1.64.77-2.8.77s-2.03-.36-2.68-1.09c-.65-.73-.97-1.76-.97-3.08,0-1.25.35-2.27,1.06-3.05.71-.79,1.59-1.19,2.65-1.19s1.87.34,2.44,1.02.86,1.62.86,2.83v.68Zm-1.32-1.09c0-.74-.19-1.32-.54-1.73-.35-.41-.84-.62-1.47-.62s-1.12.22-1.55.65c-.42.43-.69,1-.78,1.7h4.34Zm7.09-5.98c-.25-.14-.54-.21-.86-.21-.9,0-1.35.57-1.35,1.7v1.24h1.88v1.1h-1.88v6.94h-1.28v-6.94h-1.37v-1.1h1.37v-1.3c0-.84.24-1.51.73-1.99.49-.49,1.09-.74,1.82-.74.39,0,.7.05.93.14v1.16Z" />
				<path d="m416.05,728.99c-.24,0-.45-.09-.62-.26-.17-.17-.25-.38-.25-.62s.08-.45.25-.62c.17-.18.38-.27.62-.27s.46.09.63.27c.17.17.26.38.26.62s-.09.45-.26.62c-.17.17-.38.26-.63.26Z" />
				<path d="m629.08,627.42v-17.48h4.97c1.51,0,2.71.37,3.59,1.11.89.74,1.33,1.7,1.33,2.89,0,.99-.27,1.85-.8,2.58-.54.73-1.28,1.25-2.22,1.56v.05c1.18.14,2.12.58,2.83,1.34.71.75,1.06,1.72,1.06,2.92,0,1.49-.54,2.71-1.61,3.63s-2.43,1.39-4.06,1.39h-5.09Zm2.05-15.62v5.64h2.1c1.12,0,2-.27,2.64-.8.64-.54.96-1.31.96-2.29,0-1.7-1.12-2.55-3.35-2.55h-2.35Zm0,7.48v6.29h2.78c1.2,0,2.13-.28,2.79-.85.67-.57,1-1.35,1-2.34,0-2.06-1.41-3.1-4.22-3.1h-2.35Zm20.92,8.14h-2v-1.95h-.05c-.87,1.49-2.15,2.24-3.84,2.24-1.24,0-2.22-.33-2.92-.99-.7-.66-1.05-1.53-1.05-2.62,0-2.33,1.37-3.69,4.12-4.07l3.74-.52c0-2.12-.86-3.18-2.57-3.18-1.5,0-2.86.51-4.07,1.54v-2.05c1.23-.78,2.64-1.17,4.24-1.17,2.93,0,4.4,1.55,4.4,4.66v8.12Zm-2-6.31l-3.01.41c-.93.13-1.62.36-2.1.69-.47.33-.71.91-.71,1.74,0,.61.22,1.11.65,1.5.44.38,1.02.57,1.74.57.99,0,1.81-.35,2.45-1.04.65-.7.97-1.58.97-2.64v-1.24Zm11.56,6.19c-.47.26-1.09.39-1.86.39-2.19,0-3.28-1.22-3.28-3.66v-7.38h-2.14v-1.71h2.14v-3.05l2-.65v3.69h3.14v1.71h-3.14v7.03c0,.84.14,1.43.43,1.79.28.36.76.54,1.41.54.5,0,.94-.14,1.3-.41v1.71Zm13.03.12h-2v-7.19c0-2.6-.97-3.9-2.9-3.9-.97,0-1.8.38-2.46,1.13-.67.75-1,1.71-1,2.89v7.07h-2v-18.47h2v8.07h.05c.96-1.58,2.32-2.36,4.09-2.36,2.81,0,4.22,1.69,4.22,5.08v7.69Z" />
				<path d="m665.98,826.39h-9.26v-17.47h8.87v1.85h-6.82v5.81h6.31v1.84h-6.31v6.12h7.21v1.85Zm13.48,0h-2v-7.12c0-2.65-.97-3.97-2.9-3.97-1,0-1.83.38-2.49,1.13-.65.75-.97,1.69-.97,2.84v7.12h-2v-12.48h2v2.07h.05c.94-1.58,2.31-2.36,4.09-2.36,1.36,0,2.41.44,3.13,1.33.72.88,1.08,2.15,1.08,3.81v7.63Zm9.57-.12c-.47.26-1.09.39-1.86.39-2.19,0-3.28-1.22-3.28-3.66v-7.38h-2.14v-1.71h2.14v-3.05l2-.65v3.69h3.14v1.71h-3.14v7.03c0,.84.14,1.43.43,1.79.28.36.76.54,1.41.54.5,0,.94-.14,1.3-.41v1.71Zm9.2-10.33c-.35-.27-.85-.4-1.51-.4-.85,0-1.57.4-2.14,1.21-.57.8-.85,1.9-.85,3.29v6.36h-2v-12.48h2v2.57h.05c.28-.88.72-1.56,1.3-2.05.58-.5,1.24-.74,1.96-.74.52,0,.92.06,1.19.17v2.07Zm12.13-2.02l-5.74,14.48c-1.02,2.58-2.46,3.88-4.31,3.88-.52,0-.95-.05-1.3-.16v-1.79c.43.15.82.22,1.18.22,1.01,0,1.76-.6,2.27-1.8l1-2.36-4.87-12.45h2.22l3.38,9.6c.04.12.13.44.26.95h.07c.04-.2.12-.5.24-.93l3.55-9.63h2.07Z" />
				<path d="m544.24,265.21v-17.48h4.97c1.51,0,2.71.37,3.59,1.11s1.33,1.7,1.33,2.89c0,.99-.27,1.85-.8,2.58s-1.28,1.25-2.22,1.56v.05c1.18.14,2.12.58,2.83,1.34.71.75,1.06,1.72,1.06,2.92,0,1.49-.54,2.71-1.61,3.63-1.07.93-2.43,1.39-4.06,1.39h-5.09Zm2.05-15.62v5.64h2.1c1.12,0,2-.27,2.64-.8.64-.54.96-1.31.96-2.29,0-1.7-1.12-2.55-3.35-2.55h-2.35Zm0,7.48v6.29h2.78c1.2,0,2.13-.28,2.79-.85.67-.57,1-1.35,1-2.34,0-2.06-1.41-3.1-4.22-3.1h-2.35Zm21.99,2.4h-8.81c.03,1.39.41,2.46,1.12,3.22.71.76,1.7,1.13,2.95,1.13,1.41,0,2.7-.46,3.88-1.39v1.88c-1.1.8-2.55,1.19-4.35,1.19s-3.15-.56-4.16-1.69c-1.01-1.14-1.51-2.73-1.51-4.79,0-1.94.55-3.52,1.65-4.74,1.1-1.23,2.47-1.84,4.11-1.84s2.9.53,3.79,1.58c.89,1.06,1.34,2.52,1.34,4.4v1.05Zm-2.05-1.69c0-1.15-.29-2.05-.84-2.69-.54-.64-1.3-.96-2.28-.96s-1.74.34-2.4,1.01c-.66.67-1.06,1.56-1.22,2.64h6.74Zm15.7,7.43h-2v-2.12h-.05c-.93,1.61-2.36,2.41-4.29,2.41-1.57,0-2.82-.56-3.77-1.67-.93-1.12-1.4-2.64-1.4-4.57,0-2.06.52-3.72,1.56-4.96s2.43-1.86,4.16-1.86,2.96.67,3.74,2.02h.05v-7.73h2v18.47Zm-2-5.64v-1.84c0-1.01-.33-1.86-1-2.56-.67-.7-1.51-1.05-2.53-1.05-1.22,0-2.18.45-2.88,1.34-.7.89-1.05,2.13-1.05,3.7,0,1.44.33,2.58,1,3.41.67.83,1.58,1.24,2.71,1.24s2.01-.4,2.71-1.21c.7-.8,1.05-1.82,1.05-3.05Zm12.53-4.81c-.35-.27-.85-.4-1.51-.4-.85,0-1.57.4-2.14,1.21-.57.8-.85,1.9-.85,3.29v6.36h-2v-12.48h2v2.57h.05c.28-.88.72-1.56,1.3-2.05.58-.5,1.24-.74,1.96-.74.52,0,.92.06,1.19.17v2.07Zm7.37,10.75c-1.84,0-3.32-.58-4.42-1.74-1.1-1.17-1.65-2.72-1.65-4.64,0-2.1.57-3.73,1.72-4.91,1.15-1.18,2.69-1.77,4.64-1.77s3.31.57,4.35,1.72c1.05,1.15,1.57,2.73,1.57,4.76s-.56,3.59-1.69,4.79c-1.12,1.19-2.63,1.79-4.52,1.79Zm.15-11.38c-1.28,0-2.3.44-3.05,1.32-.75.87-1.12,2.07-1.12,3.61s.38,2.64,1.13,3.5c.76.85,1.77,1.28,3.03,1.28s2.28-.42,2.97-1.26c.7-.84,1.05-2.03,1.05-3.57s-.35-2.76-1.05-3.61c-.69-.84-1.68-1.27-2.97-1.27Zm14.46,11.38c-1.84,0-3.32-.58-4.42-1.74-1.1-1.17-1.65-2.72-1.65-4.64,0-2.1.57-3.73,1.72-4.91,1.15-1.18,2.69-1.77,4.64-1.77s3.31.57,4.35,1.72c1.05,1.15,1.57,2.73,1.57,4.76s-.56,3.59-1.69,4.79c-1.12,1.19-2.63,1.79-4.52,1.79Zm.15-11.38c-1.28,0-2.3.44-3.05,1.32-.75.87-1.12,2.07-1.12,3.61s.38,2.64,1.13,3.5c.76.85,1.77,1.28,3.03,1.28s2.28-.42,2.97-1.26c.7-.84,1.05-2.03,1.05-3.57s-.35-2.76-1.05-3.61c-.69-.84-1.68-1.27-2.97-1.27Zm26.96,11.09h-2v-7.17c0-1.38-.22-2.38-.65-3-.42-.62-1.14-.93-2.14-.93-.85,0-1.58.39-2.18,1.17-.59.78-.89,1.71-.89,2.8v7.12h-2v-7.41c0-2.45-.95-3.68-2.84-3.68-.88,0-1.6.37-2.17,1.11-.57.73-.85,1.69-.85,2.86v7.12h-2v-12.48h2v1.97h.05c.89-1.51,2.18-2.27,3.88-2.27.85,0,1.6.24,2.23.72.63.47,1.07,1.09,1.3,1.86.93-1.72,2.31-2.58,4.14-2.58,2.75,0,4.12,1.69,4.12,5.08v7.69Z" />
				<path d="m549.24,291.11h-1.45v-10.98c-.11.11-.28.24-.5.39-.21.14-.45.28-.73.43-.27.14-.55.27-.85.4-.3.12-.58.22-.87.29v-1.47c.32-.09.66-.21,1.01-.35.36-.15.71-.32,1.05-.5.35-.19.68-.38.98-.58.31-.21.57-.41.8-.6h.55v12.99Zm12.42-6.4c0,1.06-.1,2-.29,2.83-.19.82-.47,1.51-.83,2.08-.36.56-.81.99-1.34,1.28-.53.29-1.13.43-1.8.43-.64,0-1.21-.14-1.71-.42-.5-.28-.92-.69-1.26-1.23-.34-.54-.6-1.2-.78-1.98-.18-.79-.27-1.68-.27-2.69,0-1.11.09-2.09.27-2.94.19-.85.46-1.56.82-2.13.36-.58.81-1.01,1.34-1.3.54-.3,1.15-.44,1.84-.44,2.66,0,4,2.17,4,6.51Zm-1.49.14c0-3.61-.86-5.42-2.58-5.42-1.81,0-2.72,1.84-2.72,5.52,0,3.43.89,5.15,2.67,5.15s2.63-1.75,2.63-5.24Z" />
				<rect x="563.87" y="278.41" width="1.28" height="3.96" />
				<path d="m574.98,287.52c0,.57-.11,1.1-.33,1.57-.21.47-.52.87-.91,1.2-.39.33-.86.59-1.41.77-.55.18-1.15.27-1.82.27-1.21,0-2.17-.23-2.89-.69v-1.56c.86.67,1.84,1.01,2.94,1.01.44,0,.84-.06,1.2-.17.36-.11.67-.27.92-.49.26-.21.46-.47.59-.77.14-.3.21-.64.21-1.02,0-1.66-1.18-2.49-3.54-2.49h-1.05v-1.23h1c2.09,0,3.14-.78,3.14-2.34,0-1.44-.8-2.16-2.39-2.16-.9,0-1.74.3-2.52.9v-1.41c.81-.48,1.77-.73,2.89-.73.53,0,1.01.07,1.44.22.43.15.8.35,1.11.62s.54.58.71.96c.17.37.26.78.26,1.23,0,1.67-.84,2.75-2.53,3.22v.04c.43.05.83.15,1.2.32.37.16.68.37.95.63.27.26.47.57.62.92.15.35.23.74.23,1.16h0Z" />
				<path d="m579.07,278.41v3.96h-1.28v-3.96h1.28Zm2.94,0v3.96h-1.28v-3.96h1.28Z" />
				<path d="m596.54,282.04l-3.05,4.59,2.99,4.48h-1.69l-1.78-2.94c-.11-.18-.25-.41-.4-.69h-.04c-.03.05-.17.28-.42.69l-1.82,2.94h-1.67l3.09-4.45-2.96-4.62h1.69l1.75,3.1c.13.23.26.47.38.71h.04l2.27-3.81h1.6Z" />
				<path d="m608.17,291.11h-1.45v-10.98c-.11.11-.28.24-.5.39-.21.14-.45.28-.73.43-.27.14-.55.27-.85.4-.3.12-.58.22-.87.29v-1.47c.32-.09.66-.21,1.01-.35.36-.15.71-.32,1.05-.5.35-.19.68-.38.98-.58.31-.21.57-.41.8-.6h.55v12.99Zm10.23-9.37c0-.39-.06-.73-.19-1.02-.12-.29-.28-.53-.5-.72-.21-.19-.45-.34-.74-.43-.28-.09-.59-.14-.92-.14-.28,0-.56.04-.83.12s-.54.18-.8.32c-.25.14-.5.3-.74.49-.24.19-.46.4-.66.63v-1.56c.41-.4.86-.7,1.36-.9.51-.21,1.13-.32,1.85-.32.52,0,1,.08,1.44.23.44.15.83.37,1.15.66.32.29.58.65.76,1.07.19.43.28.91.28,1.46,0,.5-.06.96-.18,1.36-.11.41-.29.79-.52,1.15-.23.36-.52.71-.88,1.04-.35.33-.77.67-1.25,1.01-.6.43-1.09.79-1.48,1.09-.38.3-.69.58-.92.85-.22.26-.38.52-.48.79-.09.26-.13.56-.13.9h6.33v1.3h-7.84v-.63c0-.54.06-1.02.18-1.44.12-.41.31-.81.58-1.18.27-.37.63-.74,1.06-1.12.44-.37.98-.79,1.62-1.26.46-.33.84-.65,1.15-.95.31-.3.56-.6.75-.9.19-.3.32-.61.4-.91.08-.31.12-.64.12-.99Z" />
				<rect x="622.8" y="278.41" width="1.28" height="3.96" />
				<path d="m634.51,284.71c0,1.06-.1,2-.29,2.83-.19.82-.47,1.51-.83,2.08-.36.56-.81.99-1.34,1.28-.53.29-1.13.43-1.8.43-.64,0-1.21-.14-1.71-.42-.5-.28-.92-.69-1.26-1.23-.34-.54-.6-1.2-.78-1.98-.18-.79-.27-1.68-.27-2.69,0-1.11.09-2.09.27-2.94.19-.85.46-1.56.82-2.13.36-.58.81-1.01,1.34-1.3.54-.3,1.15-.44,1.84-.44,2.66,0,4,2.17,4,6.51Zm-1.49.14c0-3.61-.86-5.42-2.58-5.42-1.81,0-2.72,1.84-2.72,5.52,0,3.43.89,5.15,2.67,5.15s2.63-1.75,2.63-5.24Z" />
				<path d="m638,278.41v3.96h-1.28v-3.96h1.28Zm2.94,0v3.96h-1.28v-3.96h1.28Z" />
				<path d="m274.25,577.39h-2.85l-6.75-7.99c-.25-.3-.41-.5-.46-.61h-.05v8.6h-2.05v-17.48h2.05v8.21h.05c.11-.18.27-.38.46-.6l6.53-7.62h2.55l-7.49,8.38,8.02,9.09Zm3.05-15.65c-.36,0-.66-.12-.91-.37-.25-.24-.38-.55-.38-.93s.13-.68.38-.93c.25-.25.56-.38.91-.38s.67.13.93.38c.26.24.39.55.39.93s-.13.66-.39.91c-.25.25-.56.38-.93.38Zm.97,15.65h-2v-12.48h2v12.48Zm9.81-.12c-.47.26-1.09.39-1.86.39-2.19,0-3.28-1.22-3.28-3.66v-7.38h-2.14v-1.71h2.14v-3.05l2-.65v3.69h3.14v1.71h-3.14v7.03c0,.84.14,1.43.43,1.79.28.36.76.54,1.41.54.5,0,.94-.14,1.3-.41v1.71Zm11.16-.45c-.96.58-2.1.87-3.41.87-1.78,0-3.22-.58-4.31-1.73-1.09-1.16-1.63-2.66-1.63-4.51,0-2.06.59-3.7,1.77-4.95,1.18-1.25,2.75-1.88,4.72-1.88,1.1,0,2.06.2,2.9.61v2.05c-.93-.65-1.92-.97-2.97-.97-1.28,0-2.32.46-3.14,1.38-.81.91-1.22,2.11-1.22,3.59s.38,2.62,1.15,3.46c.77.84,1.8,1.27,3.1,1.27,1.09,0,2.11-.36,3.07-1.08v1.9Zm13.37.57h-2v-7.19c0-2.6-.97-3.9-2.9-3.9-.97,0-1.8.38-2.46,1.13-.67.75-1,1.71-1,2.89v7.07h-2v-18.47h2v8.07h.05c.96-1.58,2.32-2.36,4.09-2.36,2.81,0,4.22,1.69,4.22,5.08v7.69Zm13.78-5.74h-8.81c.03,1.39.41,2.46,1.12,3.22s1.7,1.13,2.95,1.13c1.41,0,2.7-.46,3.88-1.39v1.88c-1.1.8-2.55,1.19-4.35,1.19s-3.15-.56-4.16-1.69c-1.01-1.14-1.51-2.73-1.51-4.79,0-1.94.55-3.52,1.65-4.74,1.1-1.23,2.47-1.84,4.11-1.84s2.9.53,3.79,1.58c.89,1.06,1.34,2.52,1.34,4.4v1.05Zm-2.05-1.69c0-1.15-.29-2.05-.84-2.69-.54-.64-1.3-.96-2.28-.96s-1.74.34-2.4,1.01c-.66.67-1.06,1.56-1.22,2.64h6.74Zm15.41,7.43h-2v-7.12c0-2.65-.97-3.97-2.9-3.97-1,0-1.83.38-2.49,1.13-.65.75-.97,1.69-.97,2.84v7.12h-2v-12.48h2v2.07h.05c.94-1.58,2.31-2.36,4.09-2.36,1.36,0,2.41.44,3.13,1.33.72.88,1.08,2.15,1.08,3.81v7.63Z" />
				<path d="m202.46,263.98h-9.07v-17.48h2.05v15.62h7.02v1.85Zm3.43-15.65c-.36,0-.66-.12-.91-.37-.25-.24-.38-.55-.38-.93s.13-.68.38-.93c.25-.25.56-.38.91-.38s.67.13.93.38c.26.24.39.55.39.93s-.13.66-.39.91c-.25.25-.56.38-.93.38Zm.97,15.65h-2v-12.48h2v12.48Zm13.84-12.48l-4.97,12.48h-1.96l-4.73-12.48h2.19l3.17,9.07c.24.67.38,1.25.44,1.74h.05c.08-.63.21-1.19.39-1.69l3.31-9.12h2.11Zm3.16-3.17c-.36,0-.66-.12-.91-.37-.25-.24-.38-.55-.38-.93s.13-.68.38-.93c.25-.25.56-.38.91-.38s.67.13.93.38c.26.24.39.55.39.93s-.13.66-.39.91c-.25.25-.56.38-.93.38Zm.97,15.65h-2v-12.48h2v12.48Zm14.39,0h-2v-7.12c0-2.65-.97-3.97-2.9-3.97-1,0-1.83.38-2.49,1.13-.65.75-.97,1.69-.97,2.84v7.12h-2v-12.48h2v2.07h.05c.94-1.58,2.31-2.36,4.09-2.36,1.36,0,2.41.44,3.13,1.33.72.88,1.08,2.15,1.08,3.81v7.63Zm14.41-1c0,4.58-2.19,6.87-6.58,6.87-1.54,0-2.89-.29-4.05-.88v-2c1.41.78,2.75,1.17,4.02,1.17,3.07,0,4.61-1.63,4.61-4.9v-1.36h-.05c-.95,1.59-2.38,2.39-4.29,2.39-1.55,0-2.8-.55-3.75-1.66-.94-1.11-1.41-2.6-1.41-4.47,0-2.12.51-3.81,1.52-5.06,1.02-1.25,2.42-1.88,4.19-1.88s2.93.67,3.74,2.02h.05v-1.73h2v11.48Zm-2-4.64v-1.84c0-.99-.34-1.84-1.01-2.55-.67-.71-1.5-1.06-2.5-1.06-1.23,0-2.2.45-2.9,1.35-.7.89-1.05,2.15-1.05,3.77,0,1.39.33,2.5,1,3.34.67.83,1.56,1.24,2.67,1.24s2.03-.4,2.73-1.19c.71-.8,1.06-1.82,1.06-3.06Z" />
				<polygon points="265.57 246.5 257.18 266.88 255.32 266.88 263.68 246.5 265.57 246.5" />
				<path d="m267.6,263.98v-17.48h4.83c6.16,0,9.24,2.84,9.24,8.52,0,2.7-.86,4.87-2.57,6.51-1.71,1.63-3.99,2.45-6.86,2.45h-4.63Zm2.05-15.62v13.77h2.61c2.29,0,4.07-.61,5.35-1.84,1.28-1.23,1.91-2.97,1.91-5.22,0-4.48-2.38-6.71-7.14-6.71h-2.73Zm16.13-.02c-.36,0-.66-.12-.91-.37-.25-.24-.38-.55-.38-.93s.13-.68.38-.93c.25-.25.56-.38.91-.38s.67.13.93.38c.26.24.39.55.39.93s-.13.66-.39.91c-.25.25-.56.38-.93.38Zm.97,15.65h-2v-12.48h2v12.48Zm14.32,0h-2v-7.12c0-2.65-.97-3.97-2.9-3.97-1,0-1.83.38-2.49,1.13-.65.75-.97,1.69-.97,2.84v7.12h-2v-12.48h2v2.07h.05c.94-1.58,2.31-2.36,4.09-2.36,1.36,0,2.41.44,3.13,1.33.72.88,1.08,2.15,1.08,3.81v7.63Zm4.72-15.65c-.36,0-.66-.12-.91-.37-.25-.24-.38-.55-.38-.93s.13-.68.38-.93c.25-.25.56-.38.91-.38s.67.13.93.38c.26.24.39.55.39.93s-.13.66-.39.91c-.25.25-.56.38-.93.38Zm.97,15.65h-2v-12.48h2v12.48Zm14.32,0h-2v-7.12c0-2.65-.97-3.97-2.9-3.97-1,0-1.83.38-2.49,1.13-.65.75-.97,1.69-.97,2.84v7.12h-2v-12.48h2v2.07h.05c.94-1.58,2.31-2.36,4.09-2.36,1.36,0,2.41.44,3.13,1.33.72.88,1.08,2.15,1.08,3.81v7.63Zm14.34-1c0,4.58-2.19,6.87-6.58,6.87-1.54,0-2.89-.29-4.05-.88v-2c1.41.78,2.75,1.17,4.02,1.17,3.07,0,4.61-1.63,4.61-4.9v-1.36h-.05c-.95,1.59-2.38,2.39-4.29,2.39-1.55,0-2.8-.55-3.75-1.66-.94-1.11-1.41-2.6-1.41-4.47,0-2.12.51-3.81,1.52-5.06,1.02-1.25,2.42-1.88,4.19-1.88s2.93.67,3.74,2.02h.05v-1.73h2v11.48Zm-2-4.64v-1.84c0-.99-.34-1.84-1.01-2.55-.67-.71-1.5-1.06-2.5-1.06-1.23,0-2.2.45-2.9,1.35-.7.89-1.05,2.15-1.05,3.77,0,1.39.33,2.5,1,3.34.67.83,1.56,1.24,2.67,1.24s2.03-.4,2.73-1.19c.71-.8,1.06-1.82,1.06-3.06Z" />
				<path d="m359.33,263.98h-2.44l-2.92-4.9c-.27-.45-.53-.84-.78-1.16-.25-.32-.51-.59-.78-.79-.26-.2-.54-.35-.85-.44-.3-.1-.64-.15-1.02-.15h-1.68v7.43h-2.05v-17.48h5.22c.76,0,1.47.1,2.11.29.65.19,1.21.48,1.68.87.48.39.85.88,1.12,1.46.27.58.4,1.26.4,2.04,0,.61-.09,1.17-.28,1.68-.18.5-.44.95-.78,1.35-.33.4-.74.74-1.22,1.02-.47.28-1,.49-1.6.65v.05c.29.13.54.28.76.45.22.16.43.36.62.58.19.23.39.49.57.78.2.28.41.62.65,1l3.28,5.25Zm-10.48-15.62v6.34h2.78c.51,0,.98-.08,1.41-.23.44-.15.82-.37,1.13-.66.32-.29.56-.65.74-1.06.18-.42.27-.89.27-1.41,0-.93-.3-1.66-.91-2.18-.6-.53-1.47-.79-2.62-.79h-2.8Zm17.75,15.92c-1.84,0-3.32-.58-4.42-1.74-1.1-1.17-1.65-2.72-1.65-4.64,0-2.1.57-3.73,1.72-4.91s2.69-1.77,4.64-1.77,3.31.57,4.35,1.72c1.05,1.15,1.57,2.73,1.57,4.76s-.56,3.59-1.69,4.79c-1.12,1.19-2.63,1.79-4.52,1.79Zm.15-11.38c-1.28,0-2.3.44-3.05,1.32-.75.87-1.12,2.07-1.12,3.61s.38,2.64,1.13,3.5c.76.85,1.77,1.28,3.03,1.28s2.28-.42,2.97-1.26c.7-.84,1.05-2.03,1.05-3.57s-.35-2.76-1.05-3.61c-.69-.84-1.68-1.27-2.97-1.27Zm14.4,11.38c-1.84,0-3.32-.58-4.42-1.74-1.1-1.17-1.65-2.72-1.65-4.64,0-2.1.57-3.73,1.72-4.91s2.69-1.77,4.64-1.77,3.31.57,4.35,1.72c1.05,1.15,1.57,2.73,1.57,4.76s-.56,3.59-1.69,4.79c-1.12,1.19-2.63,1.79-4.52,1.79Zm.15-11.38c-1.28,0-2.3.44-3.05,1.32-.75.87-1.12,2.07-1.12,3.61s.38,2.64,1.13,3.5c.76.85,1.77,1.28,3.03,1.28s2.28-.42,2.97-1.26c.7-.84,1.05-2.03,1.05-3.57s-.35-2.76-1.05-3.61c-.69-.84-1.68-1.27-2.97-1.27Zm26.91,11.09h-2v-7.17c0-1.38-.22-2.38-.65-3-.42-.62-1.14-.93-2.14-.93-.85,0-1.58.39-2.18,1.17-.59.78-.89,1.71-.89,2.8v7.12h-2v-7.41c0-2.45-.95-3.68-2.84-3.68-.88,0-1.6.37-2.17,1.11-.57.73-.85,1.69-.85,2.86v7.12h-2v-12.48h2v1.97h.05c.89-1.51,2.18-2.27,3.88-2.27.85,0,1.6.24,2.23.72.63.47,1.07,1.09,1.3,1.86.93-1.72,2.31-2.58,4.14-2.58,2.75,0,4.12,1.69,4.12,5.08v7.69Z" />
				<path d="m259.43,282.77c0,1.16-.12,2.2-.35,3.11-.23.9-.57,1.67-1.01,2.3-.44.63-.98,1.1-1.62,1.44-.64.32-1.36.49-2.18.49s-1.58-.15-2.21-.44v-1.39c.7.4,1.45.59,2.25.59.57,0,1.08-.12,1.53-.35.45-.24.84-.58,1.15-1.03.31-.45.55-1.01.72-1.67.17-.66.25-1.42.25-2.28h-.04c-.54,1.09-1.49,1.64-2.83,1.64-.54,0-1.04-.09-1.5-.28-.45-.19-.85-.47-1.18-.82-.33-.35-.59-.77-.77-1.26s-.27-1.02-.27-1.6c0-.63.1-1.2.3-1.72.21-.52.49-.97.85-1.34.37-.38.8-.67,1.29-.88.5-.21,1.05-.31,1.64-.31.64,0,1.2.13,1.69.39.5.25.91.63,1.25,1.13.34.49.59,1.1.77,1.82.18.72.27,1.54.27,2.47Zm-1.57-1.3c0-.49-.06-.94-.19-1.34-.12-.4-.3-.74-.52-1.03-.22-.29-.49-.51-.81-.66-.31-.16-.64-.24-1.01-.24s-.67.07-.97.21c-.3.14-.56.33-.79.58-.22.25-.39.55-.52.89-.12.34-.19.72-.19,1.13,0,.45.06.85.18,1.2.12.35.3.66.52.9.22.24.49.43.81.56.32.13.67.19,1.05.19.34,0,.65-.06.95-.19.3-.13.56-.3.78-.51.22-.22.4-.47.52-.76.13-.3.19-.61.19-.95Z" />
				<rect x="261.79" y="277.18" width="1.28" height="3.96" />
				<path d="m270.87,289.88h-1.45v-10.98c-.11.11-.28.24-.5.39-.21.14-.45.28-.73.43-.27.14-.55.27-.85.4-.3.12-.58.22-.87.29v-1.47c.32-.09.66-.21,1.01-.35.36-.15.71-.32,1.05-.5.35-.19.68-.38.98-.58.31-.21.57-.41.8-.6h.55v12.99Zm12.42-6.4c0,1.06-.1,2-.29,2.83-.19.82-.47,1.51-.83,2.08-.36.56-.81.99-1.34,1.28-.53.29-1.13.43-1.8.43-.64,0-1.21-.14-1.71-.42-.5-.28-.92-.69-1.26-1.23-.34-.54-.6-1.2-.78-1.98-.18-.79-.27-1.68-.27-2.69,0-1.11.09-2.09.27-2.94.19-.85.46-1.56.82-2.13.36-.58.81-1.01,1.34-1.3.54-.3,1.15-.44,1.84-.44,2.66,0,4,2.17,4,6.51Zm-1.49.14c0-3.61-.86-5.42-2.58-5.42-1.81,0-2.72,1.84-2.72,5.52,0,3.43.89,5.15,2.67,5.15s2.63-1.75,2.63-5.24Z" />
				<path d="m286.79,277.18v3.96h-1.28v-3.96h1.28Zm2.94,0v3.96h-1.28v-3.96h1.28Z" />
				<path d="m304.26,280.81l-3.05,4.59,2.99,4.48h-1.69l-1.78-2.94c-.11-.18-.25-.41-.4-.69h-.04c-.03.05-.17.28-.42.69l-1.82,2.94h-1.67l3.09-4.45-2.96-4.62h1.69l1.75,3.1c.13.23.26.47.38.71h.04l2.27-3.81h1.6Z" />
				<path d="m315.88,289.88h-1.45v-10.98c-.11.11-.28.24-.5.39-.21.14-.45.28-.73.43-.27.14-.55.27-.85.4-.3.12-.58.22-.87.29v-1.47c.32-.09.66-.21,1.01-.35.36-.15.71-.32,1.05-.5.35-.19.68-.38.98-.58.31-.21.57-.41.8-.6h.55v12.99Zm11.83-3.6c0,.57-.11,1.1-.33,1.57-.21.47-.52.87-.91,1.2-.39.33-.86.59-1.41.77-.55.18-1.15.27-1.82.27-1.21,0-2.17-.23-2.89-.69v-1.56c.86.67,1.84,1.01,2.94,1.01.44,0,.84-.06,1.2-.17.36-.11.67-.27.92-.49.26-.21.46-.47.59-.77.14-.3.21-.64.21-1.02,0-1.66-1.18-2.49-3.54-2.49h-1.05v-1.23h1c2.09,0,3.14-.78,3.14-2.34,0-1.44-.8-2.16-2.39-2.16-.9,0-1.74.3-2.52.9v-1.41c.81-.48,1.77-.73,2.89-.73.53,0,1.01.07,1.44.22.43.15.8.35,1.11.62s.54.58.71.96c.17.37.26.78.26,1.23,0,1.67-.84,2.75-2.53,3.22v.04c.43.05.83.15,1.2.32.37.16.68.37.95.63.27.26.47.57.62.92.15.35.23.74.23,1.16h0Z" />
				<rect x="330.52" y="277.18" width="1.28" height="3.96" />
				<path d="m342.22,283.47c0,1.06-.1,2-.29,2.83-.19.82-.47,1.51-.83,2.08-.36.56-.81.99-1.34,1.28-.53.29-1.13.43-1.8.43-.64,0-1.21-.14-1.71-.42-.5-.28-.92-.69-1.26-1.23s-.6-1.2-.78-1.98c-.18-.79-.27-1.68-.27-2.69,0-1.11.09-2.09.27-2.94.19-.85.46-1.56.82-2.13.36-.58.81-1.01,1.34-1.3.54-.3,1.15-.44,1.84-.44,2.66,0,4,2.17,4,6.51Zm-1.49.14c0-3.61-.86-5.42-2.58-5.42-1.81,0-2.72,1.84-2.72,5.52,0,3.43.89,5.15,2.67,5.15s2.63-1.75,2.63-5.24Z" />
				<path d="m345.72,277.18v3.96h-1.28v-3.96h1.28Zm2.94,0v3.96h-1.28v-3.96h1.28Z" />
				<path d="m764.33,770.64v-1.75c.2.18.44.34.72.48.28.14.58.26.89.36.31.09.63.17.94.22.31.05.6.08.87.08.92,0,1.6-.17,2.05-.5.45-.34.68-.83.68-1.47,0-.34-.08-.64-.23-.89-.15-.25-.35-.48-.62-.69-.27-.21-.58-.41-.95-.6-.36-.19-.75-.4-1.17-.61-.44-.22-.86-.45-1.24-.68-.38-.23-.72-.48-1-.76-.28-.28-.51-.59-.67-.94-.16-.35-.24-.77-.24-1.24,0-.58.13-1.08.38-1.51.25-.43.59-.79,1-1.06.41-.28.88-.48,1.41-.62.53-.14,1.07-.2,1.62-.2,1.25,0,2.16.15,2.74.45v1.67c-.75-.52-1.71-.78-2.89-.78-.32,0-.65.04-.97.11-.32.06-.61.17-.87.33-.25.15-.46.35-.62.59-.16.24-.24.54-.24.89,0,.32.06.61.18.84.12.24.3.45.54.65s.52.38.86.57c.34.18.74.38,1.18.6.45.22.89.46,1.29.71.41.25.76.52,1.07.82.31.3.55.63.73,1,.18.37.27.79.27,1.26,0,.63-.12,1.16-.37,1.59-.24.43-.57.78-.99,1.05-.41.27-.89.47-1.44.58-.54.12-1.12.19-1.72.19-.2,0-.45-.02-.74-.05-.3-.03-.6-.08-.9-.14-.31-.06-.6-.13-.88-.22-.27-.09-.49-.2-.66-.31Zm14.15.43c-.34.19-.79.28-1.36.28-1.59,0-2.38-.89-2.38-2.66v-5.37h-1.56v-1.24h1.56v-2.21l1.45-.47v2.68h2.29v1.24h-2.29v5.11c0,.61.1,1.04.31,1.3.21.26.55.39,1.03.39.37,0,.68-.1.95-.3v1.24Zm5.64.3c-1.34,0-2.41-.42-3.22-1.27-.8-.85-1.2-1.98-1.2-3.38,0-1.52.42-2.71,1.25-3.57s1.96-1.28,3.38-1.28,2.41.42,3.16,1.25c.76.83,1.14,1.99,1.14,3.46s-.41,2.61-1.23,3.48c-.82.87-1.91,1.3-3.29,1.3Zm.11-8.27c-.93,0-1.67.32-2.21.96-.54.63-.82,1.51-.82,2.62s.27,1.92.82,2.54c.55.62,1.28.93,2.21.93s1.66-.3,2.16-.91c.51-.61.76-1.47.76-2.6s-.25-2.01-.76-2.62c-.5-.61-1.22-.92-2.16-.92Zm11.37.46c-.25-.19-.62-.29-1.1-.29-.62,0-1.14.29-1.56.88-.41.58-.62,1.38-.62,2.39v4.62h-1.45v-9.07h1.45v1.87h.04c.21-.64.52-1.13.95-1.49.43-.36.9-.54,1.43-.54.38,0,.67.04.87.12v1.51Zm7.98,7.6h-1.45v-1.42h-.04c-.63,1.09-1.56,1.63-2.79,1.63-.9,0-1.61-.24-2.13-.72-.51-.48-.76-1.11-.76-1.9,0-1.69,1-2.68,2.99-2.96l2.72-.38c0-1.54-.62-2.31-1.87-2.31-1.09,0-2.08.37-2.96,1.12v-1.49c.89-.57,1.92-.85,3.08-.85,2.13,0,3.2,1.13,3.2,3.38v5.9Zm-1.45-4.59l-2.19.3c-.67.09-1.18.26-1.52.5-.34.24-.51.66-.51,1.27,0,.44.16.81.47,1.09.32.28.74.42,1.27.42.72,0,1.31-.25,1.78-.75.47-.51.71-1.15.71-1.92v-.9Zm11.84,3.86c0,3.33-1.59,5-4.78,5-1.12,0-2.1-.21-2.94-.64v-1.45c1.02.57,2,.85,2.92.85,2.23,0,3.35-1.19,3.35-3.56v-.99h-.04c-.69,1.16-1.73,1.74-3.12,1.74-1.13,0-2.04-.4-2.73-1.2-.69-.81-1.03-1.89-1.03-3.25,0-1.54.37-2.77,1.11-3.68.74-.91,1.76-1.36,3.05-1.36s2.13.49,2.72,1.47h.04v-1.26h1.45v8.34Zm-1.45-3.38v-1.34c0-.72-.25-1.34-.74-1.85-.48-.51-1.09-.77-1.82-.77-.9,0-1.6.33-2.11.98-.51.65-.76,1.56-.76,2.74,0,1.01.24,1.82.73,2.43.49.6,1.14.9,1.94.9s1.48-.29,1.98-.87c.51-.58.77-1.32.77-2.22Zm11.59-.07h-6.4c.02,1.01.3,1.79.82,2.34.52.55,1.23.82,2.14.82,1.02,0,1.96-.34,2.82-1.01v1.36c-.8.58-1.85.87-3.16.87s-2.29-.41-3.02-1.23c-.73-.83-1.1-1.99-1.1-3.48,0-1.41.4-2.56,1.2-3.45.8-.89,1.8-1.34,2.99-1.34s2.11.38,2.76,1.15c.65.77.97,1.83.97,3.2v.76Zm-1.49-1.23c0-.84-.21-1.49-.61-1.96-.4-.47-.95-.7-1.66-.7s-1.27.24-1.75.74c-.48.49-.77,1.13-.89,1.92h4.9Z" />
			</g>
		</g>
	)
}

export default PlanC
